import React, { Component } from "react";
// import { isMobile } from 'react-device-detect';
// import { PGLOBALS } from "../../utils/portalGlobals";
import { PGLOBALS } from "../../../commonfiles/portalGlobals";
// import {cleverTapData} from "./PassPlayerEvents";
import ParseImgURL from "../../utils/parseImgURL";
// import myplexAPI, { URL_LICENCE, URL_LICENCEDRM } from "../../api/myplexAPI";
import myplexAPI from "../../api/myplexAPI";
import blank_video from "../../assets/flowplayer/blank_video.mp4";
import { isIOS, isSafari, isMobileSafari, isMobile } from "react-device-detect";
// import Observer from "@researchgate/react-intersection-observer";
// import cleverTap from "../../common/clevertap";
// import { decryption, encryption } from "../../utils/encryption";
import { decryption, encryption } from "../../../commonfiles/encryption";
import { getURLName } from "../../../commonfiles/urlMenu";
import { slugify } from "../../../commonfiles/stringSlugify";
// import cleverTap from "../../common/clevertap";
// import rewind from "../../assets/images/10sec_rewind.png"
// import forward from "../../assets/images/10sec_forward.png"
// import "./Flowplayerskin.css";
// import './video-js.min.css';
// import './videojs.skin.min.css';
import "./ima.min.css";
// import { Fingerprint } from "../../utils/fingerprint";
import { clock } from "../../utils/clock";
import { heartbeat } from "../../utils/heartbeat";
import { carouselPatnerLogos } from "../../utils/partnerLogos";
import Modalview from "./Modalview";
// import G1popup from "../Uicomponents/G1popup";
// import watermarklogo from "../../assets/images/watermark_logo1.png"
// import axios from "axios";
// import firebase from "../../analytics/firebase";
import { queryStringParse } from "../../utils/portalhelper";
import { withRouter } from "react-router";
import lensEvents from "../../LensAnalytics";
// import firebaseEvents from "../../common/firebaseEvents";
import playermute from "../../assets/images/mute.png";
import playerunmute from "../../assets/images/unmute.png";
// import { duration } from "moment";
//import fire from "../../analytics/firebase";
//import '@videojs/themes/dist/forest/index.css';
import SubscriptionAlertBox from "./SubscriptionAlertBox";

class PassPlayer extends Component {
	_isMounted = false;
	isPaused = false;
	pauseInterval = null;
	tabName = "";
	contentPosition = 0;
	carouselPosition = "";
	seekedStart = 0;
	contentSource = "";
	sourceName = "";
	studioname = "";
	completed = "";
	flag = 1;
	timer = 0;
    tobaccoStripShowAfterContentComplete = false;
	constructor(props) {
		super(props);
		this.state = {
			contentDetails: [],
		};
		// console.log(props)
		this.flowPlayerError = this.flowPlayerError.bind(this);
		this.subscribeAlertClose = this.subscribeAlertClose.bind(this);
		this._isMounted = false;
		this.state = {
			VideoData: [],
			errorMsg: null,
			live_pingtime: 30,
			content_pingtime: 15,
			adId: "",
			// clever_tap_error_message: null,
			// clever_tap_error_code: null,
			flowPlayerError: false,
			partnerLogoLink: false,
			toastMessage: null,
			ui: "",
			showPopUp: false,
			data: "",
			subtitleUrl: "",
			subtitleShow: false,
			videoStatus: "",
			curTime: new Date(),
			isPPVInterval: false,
			isPaused: false,
			thumbnailSeekPreview: "",
			checkingThumbnail: false,
			skipIntro: "",
			startVideo: true,
			profileData: [],
			subscribeAlertPopup: false,
			subscribemode: '',
			subscribetid: '',
			showAdBlockerPopUp:false,
			adBlockerTitle: 'Uh, oh! It looks as if you are using an Ad Blocker tool.',
			adBlockerMessage: 'Please disable Ad Blocker to continue viewing our content with a free account.Else, if you would like to continue watching without ads, you may also choose to subscribe to our premium plan for a complete ad-free streaming experience.',
			adBlockerButtonText: 'Go Ad-free',
			mouTimestamp : '',
			tobaccoAd: false,
			tobaccoAdUrl:""
		};
		this.scripts = [
			// "/videojs/video.min.js",

			// "/videojs/video-7.9.6.min.js",
			// "/videojs/video--7.10.2.min.js",
			"/videojs/video_7.20.2.min.js",
			"//imasdk.googleapis.com/js/sdkloader/ima3.js", // remove kaspersky blocking
			"//imasdk.googleapis.com/pal/sdkloader/pal.js",
			// "https://googleads.github.io/videojs-ima/node_modules/videojs-contrib-ads/dist/videojs.ads.min.js",
			"/videojs/can-autoplay.min.js",
			"/videojs/videojs-contrib-ads.min.js", // remove kaspersky blocking
			// "/videojs/videojs-contrib-eme.min.js",
			"/videojs/videojs-contrib-eme.new.min.js",
			// "/videojs/videojs-contrib-quality-levels.js",
			"/videojs/" + process.env.REACT_APP_PLAYERLICENCE_FILE,
			// "/videojs/nuevo_qa.min.js",
			//"/videojs/nuevo.min.js",
			"/videojs/videojs.ima.min.js",
			//"/videojs/videojs-http-source-selector.js",
			"/videojs/current.js",
			// "/videojs/videojs-seek-buttons.min.js",
			"/videojs/videojs.thumbnails.min.js",
			"/videojs/videojs.hotkeys.min.js",
			// "/videojs/videojs-max-quality-selector.min.js",
		];
	}

	flowPlayerError() {
		this.setState({ flowPlayerError: false });
	}

	subscribeAlertClose() {
		this.setState({ subscribeAlertPopup: false, showAdBlockerPopUp:false });
	}

	componentDidMount() {
		this.getproperties();
		if (sessionStorage.getItem(this.props.match.params.Id)) {
			var carosuelDetTab = sessionStorage
				.getItem(this.props.match.params.Id)
				.split("@@");

			if (carosuelDetTab.length > 0) {
				this.carouselPosition = carosuelDetTab[0];
				this.contentPosition = parseInt(carosuelDetTab[1]);
				this.tabName = carosuelDetTab[2];
				this.contentSource = carosuelDetTab[3];
				this.sourceName = carosuelDetTab[4];
			}
		}
		// if(localStorage.getItem("wintimer")===null||localStorage.getItem("wintimer")===undefined){
		localStorage.setItem("wintimer", 600);
		// }
		// console.log(this.props.contentinfo[0].thumbnailSeekPreview);
		// console.log("isios",isIOS,"issfari",isSafari,'ismac',isMacOs)
		this._isMounted = true;

		// const s = document.createElement("script");
		// var objTo = document.getElementById('companionDiv');
		// s.type = "text/javascript";
		// s.async = true;
		// s.innerHTML = "googletag.cmd.push(function() { googletag.display('companionDiv'); })";
		// objTo.appendChild(s);
		// console.log("componentDidMount",this.props.Auth);
		if (this.props.location.search !== "") {
			let params = queryStringParse(this.props.location.search);
			if (params.status !== undefined) {
				// lensEvents.paymentStatus();
				if (params.status === "SUCCESS") {
					// console.log('payyyment succe')
					//payment success

					// firebaseEvents.contentSubscribed(this.props);
					let contLang = this.props.contentinfo[0].content.language[0];
					let contName = this.props.contentinfo[0].generalInfo.title
						.trim()
						.replace(/ /gi, "_");
					let evtName = `${contName}_${contLang}_payment_success`;
					let uname = localStorage.getItem("userName");
					let uemail = localStorage.getItem("userMail");
					let mobileNum = localStorage.getItem("mobileNum");
					let price =
						this.props.contentinfo[0].packages[0].priceDetails[0].price;
					let evtValue = `${uname}_${uemail}_${mobileNum}_${price}`;
					let firbaseCheck = `${evtName}${uemail}`;
					let subTime = `${firbaseCheck}_SubTime`; // subscribed Time

					if (localStorage.getItem(firbaseCheck) === null) {
						// console.log('payyyment succe if')
						localStorage.setItem(firbaseCheck, 1);
						localStorage.setItem(subTime, new Date().getTime());
						// firebase.analytics().logEvent("payment_success", {
						//   info: evtValue,
						// });
						// firebase.analytics().logEvent(evtName, {
						//   info: evtValue,
						// });
					} else {
						// console.log('payyyment succe else')
						let lTime = localStorage.getItem(subTime);
						let gTime = new Date().getTime();
						let twoDaysTime = 48 * 60 * 60 * 1000;
						if (gTime - lTime > twoDaysTime) {
							// console.log('payyyment succe else with condition')
							localStorage.setItem(subTime, new Date().getTime());
							// firebase.analytics().logEvent("payment_success", {
							//   info: evtValue,
							// });
							// firebase.analytics().logEvent(evtName, {
							//   info: evtValue,
							// });
						}
					}
				} else {
					//payment failed
					// console.log('payment failed')
					let contLang = this.props.contentinfo[0].content.language[0];
					let contName = this.props.contentinfo[0].generalInfo.title
						.trim()
						.replace(/ /gi, "_");
					let evtName = `${contName}_${contLang}_payment_failed`;
					let uname = localStorage.getItem("userName");
					let uemail = localStorage.getItem("userMail");
					let mobileNum = localStorage.getItem("mobileNum");
					let price =
						this.props.contentinfo[0].packages[0].priceDetails[0].price;
					let evtValue = `${uname}_${uemail}_${mobileNum}_${price}`;
					//let firbaseCheck=`${evtName}${uemail}`;

					let firbaseCheck = `${evtName}${uemail}`;
					let firbaseCheckTime = `${firbaseCheck}_Time`;
					if (localStorage.getItem(firbaseCheck) === null) {
						// console.log('payment fialed if')
						localStorage.setItem(firbaseCheck, 1);
						localStorage.setItem(firbaseCheckTime, new Date().getTime());
						// firebase.analytics().logEvent("payment_failed", {
						//   info: evtValue,
						// });
						// firebase.analytics().logEvent(evtName, {
						//   info: evtValue,
						// });
					} else {
						// console.log('payment fialed else')
						let lTimeSec = localStorage.getItem(firbaseCheckTime);
						let gTimeSec = new Date().getTime();
						if (gTimeSec - lTimeSec > 200000) {
							// console.log('payment fialed else condition')
							localStorage.setItem(firbaseCheckTime, new Date().getTime());
							// firebase.analytics().logEvent("payment_failed", {
							//   info: evtValue,
							// });
							// firebase.analytics().logEvent(evtName, {
							//   info: evtValue,
							// });
						}
					}
				}
			}
		}
		// this.updatePlayerWithsrc()
		if (this._isMounted) {
			var that = this;
			// window.apstag.init({ pubID: 'e23e80e2-e655-44aa-a417-5931f830f59d',  videoAdServer: 'DFP' });
			// window.apstag.fetchBids(
			//   { slots: [{ slotID: "manoramamaxvod", mediaType: "video" }] },
			//   function (bids) {
			//     handleVideoBids(bids);
			//   }
			// );
			// function handleVideoBids(bids) {
			//   console.log("bids", bids);
			//   if (bids.length > 0) {
			//     console.log("bids", bids);
			//   }
			// }
			if (window.videojs) {
				// Fingerprint().then(function (value) {
				//   if (window.dashjs !== undefined) {
				that._getVideoURL(0);
				//   } else {
				//     that.Loadscript();
				//   }
				// });
			} else {
				// Fingerprint().then(function (value) {
				that.Loadscript();
				//});
			}
		}
		//this.addVideojsHotkeyScript();
		// document.addEventListener(
		//   "visibilitychange",
		//   this.minimizeBrowserWindowMouHandler
		// );
		// console.log("pp", this.props)
	}

	// testfun = () =>{
	//   alert();
	// }

	componentDidUpdate(prevProps) {
		if (this._isMounted) {
			if (prevProps.videoId !== this.props.videoId) {
				if (sessionStorage.getItem(this.props.match.params.Id)) {
					var carosuelDetTab = sessionStorage
						.getItem(this.props.match.params.Id)
						.split("@@");

					if (carosuelDetTab.length > 0) {
						this.carouselPosition = carosuelDetTab[0];
						this.contentPosition = parseInt(carosuelDetTab[1]);
						this.tabName = carosuelDetTab[2];
						this.contentSource = carosuelDetTab[3];
						this.sourceName = carosuelDetTab[4];
					}
				}
				// console.log("componentDidUpdate")
				if (
					this.state.videoStatus !== "ERR_USER_NOT_SUBSCRIBED" &&
					this.state.videoStatus !== "ERR_NON_LOGGED_USER"
				) {
					this.videoStoppedEventNew();
				}
				// this.videoStoppedEventNew();
				//this.addVideojsHotkeyScript();
				this._getVideoURL(1);
			}
			//console.log("wintimeudate")
			// localStorage.setItem("wintimer",600)
		}
	}

	componentWillUnmount() {
		var container = document.getElementById("player");
		if (document.pictureInPictureElement) {
			document.exitPictureInPicture();
		}
		if (container !== null) {
			// if (window.videojs(container)) {
			if (
				this.state.videoStatus !== "ERR_USER_NOT_SUBSCRIBED" &&
				this.state.videoStatus !== "ERR_NON_LOGGED_USER"
			) {
				let player = window.videojs && window.videojs(container);
				//  console.log("player status",player.paused());

				if (!player.paused()) {
					this.playerUpdate(this.state.data, "pause", player);
				}

				this.videoStoppedEventNew();
			}
			// this.videoStoppedEventNew();
			// console.log('unmount')

			window.videojs && window.videojs(container).dispose();
			// }
		}
		clock.destroy();
		if (this.pauseInterval) {
			clearInterval(this.pauseInterval);
		}
		// const box = document.getElementById("hotkeys");
		// //console.log("box ",box)
		// if(box !== null){
		// 	document.getElementById("hotkeys").remove();
		// }
	}

	minimizeBrowserWindowMouHandler = () => {
		// debugger;
		if (document.hidden) {
			// console.log(document.hidden);

			// console.log(this.state.videoStatus)

			if (
				this.state.videoStatus !== "ERR_USER_NOT_SUBSCRIBED" &&
				this.state.videoStatus !== "ERR_NON_LOGGED_USER"
			) {
				this.videoStoppedEventNew();
			}

			clock.clear();
		}
	};
	videoStoppedEventNew = () => {
		// if (this.props.Auth) {
		if (
			this.state.videoStatus !== "ERR_USER_NOT_SUBSCRIBED" &&
			this.state.videoStatus !== "ERR_NON_LOGGED_USER"
		) {
			try {
				// var container = document.getElementById("player");
				// var y = window.videojs(container);
				const timestamp = this.state.mouTimestamp ? this.state.mouTimestamp : Math.floor(Date.now());
				
				let duration;
				duration = window.timer;
				let tab = localStorage.getItem("tabName");
				let cTitle = localStorage.getItem("source details");
				let source = localStorage.getItem("source");
				let os = localStorage.getItem("os");
				let trackingId = localStorage.getItem("trackingId")
				let contentPosition = this.contentPosition
				let carouselPosition = this.carouselPosition
				const contentType = this.props.contentinfo[0].generalInfo.type;
				if (!this.contentPosition) {
					var carosuelDetTab = sessionStorage
						.getItem(this.props.match.params.Id)
						?.split("@@");
					if (carosuelDetTab && carosuelDetTab.length > 0) {
						contentPosition = carosuelDetTab[0];
						carouselPosition = parseInt(carosuelDetTab[1]);
						this.tabName = carosuelDetTab[2];
						this.contentSource = carosuelDetTab[3];
						this.sourceName = carosuelDetTab[4];
					}

				}

				// console.log(this.state.data)
				if(trackingId !=="" && trackingId !== undefined && trackingId !== null){
					localStorage.setItem("trackingId","")
				}
				myplexAPI
					.updatePlayerMou(
						this.state.data.generalInfo._id,
						duration,
						timestamp,
						this.state.data.mediaSessionToken,
						tab,
						cTitle,
						source,
						contentPosition,
						carouselPosition,
						os, contentType, trackingId
					)
					.then((res) => {
						// console.log(res)
					});
			} catch (err) {
				//console.log(err);
			}
		}
		// }
	};
	errorEncountered = (code, message) => {
		// const data = window.cleverTap_data;
		// data["error source"] = "video stopped";
		// data["error code"] = code;
		// data["reason for failure"] = message;
		// console.log(data);
		// cleverTap.errorEncountered(data);
	};
	disableMediaPlaybackNotification = () => {
		const player = document.querySelector("video");
		if (player !== null) {
			player.src = "";
		}
	};
	Loadscript = () => {
		if (this.scripts.length > 0) {
			const scriptSrc = this.scripts.shift();
			const elem = document.createElement("script");
			elem.src = scriptSrc;
			elem.onload = (e) => {
				this.Loadscript();
			};
			elem.onerror = () => {
				this.Loadscript();
			};

			return document.head.appendChild(elem);
			
		}
		//this.addVideojsHotkeyScript();
		this._getVideoURL(0);
		//return onComplete();
	};
	// addVideojsHotkeyScript = () => {
	// 	const box = document.getElementById("hotkeys");
	// 	//console.log("box ",box)
	// 	if(box === null){
	// 		//const scriptSrc1 = scripts.shift();
	// 		const elemlive = document.createElement("script");
	// 		elemlive.id = "hotkeys";
	// 		elemlive.src = '/videojs/videojs.hotkeys.min.js';
	// 		document.head.appendChild(elemlive);
	// 	}
	// }
	queryStringParse = (string) => {
		let parsed = {};
		if (string !== "") {
			string = string.substring(string.indexOf("?") + 1);
			let p1 = string.split("&");
			p1.map(function (value) {
				let params = value.split("=");
				return (parsed[params[0]] = params[1]);
			});
		}
		//console.log("dddd - ", parsed)
		return parsed;
	};

	_videoPlay = () => {
		const auth = this.props.Auth;
		// var language = '';
		var elem = document.getElementById("player_html5_api");
		if (elem !== null) {
			var api = window.videojs(elem);

			elem.onclick = (e) => {
				// console.log(e);
				if (auth) {
					// console.log(api.paused());
					if (api.paused()) {
						document.querySelector(".vjs-big-play-button").style.display =
							"block";

						api.pause();
					}
					if (api.paused() == false) {
						document.querySelector(".vjs-big-play-button").style.display =
							"none";

						api.play();
					}
				}
			};
		}
	};
	closePopUp = () => {
		// console.log('working');
		this.setState({
			ui: "",
			showPopUp: false,
		});
	};
	_getVideoURL = (status) => {
		if (this._isMounted) {
			const items = [];
			var mediaURL = `content/v3/media/${this.props.videoId
				}?payload=${encryption(
					JSON.stringify({
						fingerprint: localStorage.getItem("fingerprint"),
						network: "WIFI",
						fields:
							"videos,videoInfo,images,contents,generalInfo,subtitles,thumbnailSeekPreview,skipConfig,tags",
						mcc: "404",
						postalCode: "500033",
						consumptionType: "stream",
						mnc: "13",
						ucv: "2",
						"x-myplex-tenant-id": process.env.REACT_APP_TENANT,
					}),
					"Nzro6xid5NLofGO7"
				).replace(/\+/g, "%2b")}
        &version=1`;
			myplexAPI.getMediaAPi(mediaURL).then((response) => {
				//debugger;
				response.data = JSON.parse(
					decryption(response.data.response, "Nzro6xid5NLofGO7")
				);
				//console.log('media', response.data)
				// console.log('media', JSON.stringify(response.data))
				this.setState({mouTimestamp : Math.floor(Date.now())});
				// lensEvents.postvideoevents()
				// myplexAPI.getContentVideo(this.props.videoId).then(response => {
				const response_status = response.data.status;
				if (response_status === "SUCCESS") {
					if (response.data.results.length > 0) {
						//this.setState({studioname:response.data.results[0].publishingHouse.publishingHouseName})
						this.studioname =
							response.data.results[0].publishingHouse.publishingHouseName;
						// console.log("log123",response.data.results[0].generalInfo.type);
						if (response.data.results[0].generalInfo.type == "tvepisode") {
							// console.log(response.data.results[0]);
							this.sourceName = `${response.data.results[0].globalServiceName} | ${response.data.results[0].content.siblingOrder}`;
							// console.log("123",this.sourceName );
						}
						// console.log('urls', response.data.results[0].videos)
						if (
							response.data.results[0].subtitles &&
							response.data.results[0].subtitles.values.length > 0
						) {
							// console.log(response.data.results[0].subtitles);
							this.setState({
								subtitleShow: true,
								subtitleUrl:
									response.data.results[0].subtitles.values[0].link_sub.replace(
										".srt",
										".vtt"
									),
							});
						}
						this.setState({
							contentDetails: response.data.results[0],
						});
						if (
							response.data.results[0].skipConfig &&
							response.data.results[0].skipConfig.skipIntro.length > 0
						) {
							const skipIntro = response.data.results[0].skipConfig.skipIntro;
							const findSkipIntro = skipIntro.find(
								(item) =>
									item.action === "skipIntro" || item.skipType === "skipIntro"
							);
							// console.log('findSkipIntro ',findSkipIntro)
							if (findSkipIntro) {
								this.setState({
									skipIntro: findSkipIntro,
								});
							}
						}
						// try {
						//     const thumbnailSeekPreview = response.data.results[0].thumbnailSeekPreview;
						// console.log(response.data.results[0].thumbnailSeekPreview)
						if (
							response.data.results[0] &&
							response.data.results[0].thumbnailSeekPreview
						) {
							// console.log(response.data.results[0].thumbnailSeekPreview)
							this.setState({
								thumbnailSeekPreview:
									response.data.results[0].thumbnailSeekPreview,
							});
						} else {
							this.setState({
								thumbnailSeekPreview: "",
							});
						}
						this.setState({
							checkingThumbnail: true,
						});
						// }catch (e) {
						//     console.log('thumbnailSeekPreview error', e);
						// }
						if (
							response.data.results[0].videos.status === "SUCCESS" &&
							response.data.results[0].videos.values.length
						) {
							if (response.data.results[0].videos.showWatermark !== undefined) {
								if (response.data.results[0].videos.showWatermark) {
									let partnerLogos = carouselPatnerLogos(
										response.data.results[0].publishingHouse.publishingHouseName
									);
									this.setState({
										partnerLogoLink: partnerLogos.water_mark,
									});
								}
							}
							response.data.results[0].videos.values.forEach((item) => {
								if (
									(isIOS || isMobileSafari || isSafari) &&
									item.format !== "hls"
								) {
									let fairplaycert = "";
									let type = item.format;
									if (
										item.type === "streaming" &&
										item.format === "hls-fp-aapl"
									) {
										fairplaycert = item.fairplayCertUrl;
										type = "hlsaes";

										items.push({
											src: item.link,
											format: item.format ? item.format : "",
											type: PGLOBALS.VIDEO_FORMATS[[type]],
											label: item.profile,
											res: item.resolution,
											results: item,
											licenseUrl: item.licenseUrl,
											fairplaycert: fairplaycert,
										});
									}
								} else {
									if (
										(item.type === "streaming" || item.type === "hlsaes") &&
										item.format === "dash" &&
										item.profile === "High"
									) {
										// console.log(item.profile,item);
										items.unshift({
											src: item.link,
											format: item.format ? item.format : "",
											type: PGLOBALS.VIDEO_FORMATS[[item.format]],
											label: item.profile,
											res: item.resolution,
											results: item,
											licenseUrl: item.licenseUrl,
											fairplaycert: "",
										});
									} else if (
										(item.type === "streaming" || item.type === "hlsaes") &&
										item.format === "dash" &&
										item.profile === "Low"
									) {
										// console.log(item.profile,item);
										items.push({
											src: item.link,
											format: item.format ? item.format : "",
											type: PGLOBALS.VIDEO_FORMATS[[item.format]],
											label: item.profile,
											res: item.resolution,
											results: item,
											licenseUrl: item.licenseUrl,
											fairplaycert: "",
										});
									} else if (
										item.type === "streaming" &&
										item.format === "hls"
									) {
										// console.log(item.profile,item);
										items.push({
											src: item.link,
											format: item.format ? item.format : "",
											type: PGLOBALS.VIDEO_FORMATS[[item.format]],
											label: item.profile,
											res: item.resolution,
											results: item,
											licenseUrl: item.licenseUrl,
											fairplaycert: "",
										});
									}
								}
							});
							if (items.length > 0) {
								// console.log(items, "checking for source tag");
								//console.log("window.google ",window.google);
								//console.log("featuresads ",response.data.results[0]);
								// if(window.google && window.google.ima){
								// 	window.apstag.fetchBids(
								// 		{ slots: [{ slotID: "manoramamaxvod", mediaType: "video" }] },
								// 		(bids) => {
								// 			if (status === 1) {
								// 				this._initPlayer(
								// 					items[0].type,
								// 					items[0].src,
								// 					response.data.results[0].images.values,
								// 					response.data.results[0],
								// 					items[0].results,
								// 					response_status,
								// 					items[0].licenseUrl,
								// 					items[0].fairplaycert,
								// 					bids
								// 				);
								// 			} else {
								// 				this._initPlayer(
								// 					items[0].type,
								// 					items[0].src,
								// 					//  "video/mp4",
								// 					//  blank_video,
								// 					response.data.results[0].images.values,
								// 					response.data.results[0],
								// 					items[0].results,
								// 					response_status,
								// 					items[0].licenseUrl,
								// 					items[0].fairplaycert,
								// 					bids
								// 				);
								// 			}
								// 			//that.handleVideoBids(bids);
								// 		})
								// }else{
								// 	console.log("response.data.results[0].features.ads ",response.data.results[0].features.ads);
								// 	if(response.data.results[0].features.ads === false){										
								// 		this._initPlayer(
								// 			items[0].type,
								// 			items[0].src,
								// 			response.data.results[0].images.values,
								// 			response.data.results[0],
								// 			items[0].results,
								// 			response_status,
								// 			items[0].licenseUrl,
								// 			items[0].fairplaycert,
								// 			[]
								// 		);
								// 	}
								// }
								if (response.data.results[0] && response.data.results[0].features && response.data.results[0].features.ads === false) {
									this.setState({"showAdBlockerPopUp":false});
									this._initPlayer(								
									  items[0].type,								
									  items[0].src,								
									  response.data.results[0].images.values,								
									  response.data.results[0],								
									  items[0].results,								
									  response_status,								
									  items[0].licenseUrl,								
									  items[0].fairplaycert,								
									  []								
									);								
								  }else{
									if(window.google && window.google.ima){										
										this.setState({"showAdBlockerPopUp":false});						
										window.apstag.fetchBids(								
											{ slots: [{ slotID: "manoramamaxvod", mediaType: "video" }] },								
											(bids) => {							
												this._initPlayer(								
												items[0].type,								
												items[0].src,								
												response.data.results[0].images.values,								
												response.data.results[0],								
												items[0].results,								
												response_status,								
												items[0].licenseUrl,								
												items[0].fairplaycert,								
												bids								
												);								
										});	
									}else{
										this.setState({"showAdBlockerPopUp":true});
									}						
								}
								// if (status === 1) {
								// 	this._initPlayer(
								// 		items[0].type,
								// 		items[0].src,
								// 		response.data.results[0].images.values,
								// 		response.data.results[0],
								// 		items[0].results,
								// 		response_status,
								// 		items[0].licenseUrl,
								// 		items[0].fairplaycert
								// 	);
								// } else {
								// 	this._initPlayer(
								// 		items[0].type,
								// 		items[0].src,
								// 		//  "video/mp4",
								// 		//  blank_video,
								// 		response.data.results[0].images.values,
								// 		response.data.results[0],
								// 		items[0].results,
								// 		response_status,
								// 		items[0].licenseUrl,
								// 		items[0].fairplaycert
								// 	);
								// }
								this.heartbeatFunction();
							}
						} else {
							const results = response.data.results[0];
							// console.log("popresults",results.videos)
							if (
								results.videos.status !== "ERR_NON_LOGGED_USER" &&
								results.videos.message !==
								"Content is not free, user has not subscribed"
							) {
								let popupData = {
									"pop-up id": "",
									"pop-up name": "player popup",
									"pop-up message": results.videos.message,
								};
								// firebaseEvents.popUpShowed(popupData);
								lensEvents.popUpShowed(popupData);
								let popUpResponseData = {
									"pop-up id": "",
									"pop-up name": "player popup",
									response: "automatic close",
									value: "automatic close",
								};
								// firebaseEvents.popUpResponse(popUpResponseData);
								lensEvents.popUpResponse(popUpResponseData);
								this.setState({
									// clever_tap_error_message: results.videos.status,
									// clever_tap_error_code: response.data.code,
									//flowPlayerError:true,
									toastMessage: results.videos.message,
								});
							}
							var link = "";
							// console.log(response.data.results[0].videos.status);
							if (
								response.data.results[0].videos.status ===
								"ERR_USER_NOT_SUBSCRIBED"
							) {
								this.setState({
									videoStatus: response.data.results[0].videos.status,
								});
								link = blank_video;
							}

							if (this.props.Auth) {
								this._initPlayer(
									"video/mp4",
									link,
									results.images.values,
									results,
									results,
									response_status,
									"",
									"",
									""
								);
							} else {
								this._initPlayer(
									"video/mp4",
									blank_video,
									results.images.values,
									results,
									results,
									response_status,
									"",
									"",
									""
								);
							}
							if (
								response.data.results[0].videos.status === "ERR_NON_LOGGED_USER"
							) {
								// document.getElementById("profile_img").click();
							}
						}
						this.setState(
							{
								VideoData: response.data.results,
							},
							() => {
								this.props.callBack &&
									this.props.callBackTvShow(response.data.results);
							}
						);
					} else if (response.data.ui) {
						if (response.data.ui.action === "popup") {
							try {
								// const data = this.props.contentinfo[0];
								// const auth = window.auth;
								// const video_info = {
								//   src: null,
								//   format: null,
								//   type: null,
								//   label: null,
								//   res: null,
								//   results: null,
								//   licenseUrl: null
								// };
								// const clever_tap_data = this.cleverTapData(data, auth, video_info);
								// cleverTap.videoDetailsViewed(clever_tap_data);
								// console.log(clever_tap_data)
							} catch (err) {
								// console.error(err);
							}
							this.setState({
								ui: response.data.ui,
								showPopUp: true,
							});
						}
					}
				} else if (response_status === "ERR_INTERNAL_SERVER_ERROR") {
					this.setState({
						errorMsg: response.data.message,
						toastMessage: response.data.ui.message,
					});
					const content_id = this.props.videoId;
					const title = null;
					const globalServiceName = null;
					const message = response.data.message;
					this.errorEncountered(
						response.data.code,
						message,
						content_id,
						title,
						globalServiceName
					);
					window.videojs("#player", {
						muted: true,
						ratio: 9 / 16,
						clip: {
							sources: [
								{
									type: "video/mp4",
									src: blank_video,
								},
							],
						},
					});
				} else {
					this.setState({
						toastMessage: response.data.ui.message,
					});
				}
			});
		}
	};

	subscription = (mode, tid) => {
		//console.log("this.state.videoStatus ",this.state.videoStatus);
		// myplexAPI.ybSubscription(this.props.videoId, mode, tid).then((response) => {
		//   // console.log(response);
		//   if (
		//     response.data.status === "SUCCESS" &&
		//     response.data.message ===
		//       "Sorry, we are facing some technical issue! Please try later!"
		//   ) {
		//     try {
		//       if (response.data.ui) {
		//         if (response.data.ui.action) {
		//           this.setState({
		//             toastMessage: response.data.ui.message,
		//           });
		//         }
		//       }
		//     } catch (e) {
		//       // console.log(e);
		//     }
		//   } else if (response.data.status === "SUCCESS") {
		//     // console.log(isIOS);
		//     if (!isIOS) {
		//       let contLang = this.props.contentinfo[0].content.language[0];
		//       let content_name = this.props.contentinfo[0].generalInfo.title;
		//       let new_content_name = content_name.trim().replace(/ /gi, "_");
		//       let evt_name = `${new_content_name}_${contLang}_buy_clicked`;
		//       let info_val = `${this.props.contentinfo[0].generalInfo.type}_${new_content_name}_${this.props.contentinfo[0].generalInfo._id}`;
		//       // console.log(evt_name);
		//       // firebase.analytics().logEvent("buy_clicks", { info: info_val });
		//       // firebase.analytics().logEvent(evt_name, { info: info_val });
		//     }
		//     // if (localStorage.getItem("ProfileUpdate") == "true") {
		//     //   localStorage.setItem("redirectUrl", response.data.ui.redirect);
		//     //   this.props.history.push("/editprofile");
		//     // } else {
		//     window.location.assign(response.data.ui.redirect);
		//     // }
		//   } else if (response.data.status === "ERR_NON_LOGGED_USER") {
		//     localStorage.setItem(
		//       "redirectUrl",
		//       this.props.location.pathname + this.props.location.search
		//     );
		//     // this.props.history.push("/login");
		//     this.getSsoClientId();
		//     // window.location.href = 'https://id.manoramaonline.com/authorize?scope=openid+email+profile+offline_access&response_type=code+token+id_token&client_id=max-apalya-dev&redirect_uri=https://pwastagmmtv.myplex.com/login&state=1135778640&nonce=212883085';
		//   }
		// });
		var userPackages = sessionStorage.getItem("userPackages");
		var userType = '';
		if(userPackages !== undefined && userPackages !== null){
			userPackages = JSON.parse(userPackages);
			userType = userPackages.userType;
		}
		if (this.state.videoStatus === "ERR_NON_LOGGED_USER") {
			localStorage.setItem(
				"redirectUrl",
				this.props.location.pathname + this.props.location.search
			);
			// this.props.history.push("/login");
			this.getSsoClientId();
			// window.location.href = 'https://id.manoramaonline.com/authorize?scope=openid+email+profile+offline_access&response_type=code+token+id_token&client_id=max-apalya-dev&redirect_uri=https://pwastagmmtv.myplex.com/login&state=1135778640&nonce=212883085';
		}else if(this.state.videoStatus === "ERR_USER_NOT_SUBSCRIBED" && userType === 'authenticated'){
			this.clickSubscribe();
		}
		// else if(this.state.videoStatus === "ERR_USER_NOT_SUBSCRIBED" && userType === 'subscriber'){
		// 	this.clickSubscribe();
		// }
		else{
			this.setState({
				subscribeAlertPopup:true,
				subscribemode: mode,
				subscribetid: tid
			});
		}
	};
	clickSubscribe = () => {
		myplexAPI.ybSubscription(this.props.videoId, this.state.subscribemode, this.state.subscribetid).then((response) => {
			// console.log(response);
			if (
				response.data.status === "SUCCESS" &&
				response.data.message ===
				"Sorry, we are facing some technical issue! Please try later!"
			) {
				try {
					if (response.data.ui) {
						if (response.data.ui.action) {
							this.setState({
								toastMessage: response.data.ui.message,
							});
						}
					}
				} catch (e) {
					// console.log(e);
				}
			} else if (response.data.status === "SUCCESS") {
				// console.log(isIOS);
				if (!isIOS) {
					let contLang = this.props.contentinfo[0].content.language[0];
					let content_name = this.props.contentinfo[0].generalInfo.title;
					let new_content_name = content_name.trim().replace(/ /gi, "_");
					let evt_name = `${new_content_name}_${contLang}_buy_clicked`;
					let info_val = `${this.props.contentinfo[0].generalInfo.type}_${new_content_name}_${this.props.contentinfo[0].generalInfo._id}`;
					// console.log(evt_name);
					// firebase.analytics().logEvent("buy_clicks", { info: info_val });
					// firebase.analytics().logEvent(evt_name, { info: info_val });
				}
				// if (localStorage.getItem("ProfileUpdate") == "true") {
				//   localStorage.setItem("redirectUrl", response.data.ui.redirect);
				//   this.props.history.push("/editprofile");
				// } else {
				window.location.assign(response.data.ui.redirect);
				// }
			} else if (response.data.status === "ERR_NON_LOGGED_USER") {
				localStorage.setItem(
					"redirectUrl",
					this.props.location.pathname + this.props.location.search
				);
				// this.props.history.push("/login");
				this.getSsoClientId();
				// window.location.href = 'https://id.manoramaonline.com/authorize?scope=openid+email+profile+offline_access&response_type=code+token+id_token&client_id=max-apalya-dev&redirect_uri=https://pwastagmmtv.myplex.com/login&state=1135778640&nonce=212883085';
			}
		});
	}
	getSsoClientId = () => {
		myplexAPI.getSsoAppInfo().then((response) => {
			// console.log(response)
			if (response.data.code === 200 && response.data.status === "SUCCESS") {
				localStorage.setItem("client_id", response.data.app_id);
				// window.location.href = `https://id.manoramaonline.com/authorize?scope=openid+email+profile+offline_access+mobile&response_type=code+token+id_token&client_id=${response.data.app_id}&redirect_uri=${process.env.REACT_APP_DOMAINNAME}login&state=1135778640&nonce=212883085`;
				window.location.href = `${process.env.REACT_APP_SSO_URL}authorize?scope=openid+email+mobile+profile+offline_access&response_type=code&client_id=${process.env.REACT_APP_SSO_CLIENT_ID}&redirect_uri=${process.env.REACT_APP_DOMAINNAME}login&state=156414&nonce=177292&display=&prompt=`
			}
		});
	};
	querygam_preview = (e) => {
		for (
			var n, r = new RegExp("(?:\\?|&)" + e + "=(.*?)(?=&|$)", "gi"), c = [];
			null != (n = r.exec(document.location.search));

		)
			c[c.length] = n[1];
		return c;
	};

	createCookie = () => {
		var expires = "";
		var date = new Date();
		var value = "true";
		var midnight = new Date(
			date.getFullYear(),
			date.getMonth(),
			date.getDate(),
			23,
			59,
			59
		);
		expires = "; expires=" + midnight.toGMTString();

		var path = "/";

		document.cookie = "FirstVisit" + "=" + value + expires + "; path=" + path;
	};

	getCookie = (cname) => {
		let name = cname + "=";
		let decodedCookie = decodeURIComponent(document.cookie);
		let ca = decodedCookie.split(";");
		for (let i = 0; i < ca.length; i++) {
			let c = ca[i];
			while (c.charAt(0) == " ") {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return "";
	};
	getGenre = (generes) => {
		return generes.map(function (genere, i) {
			return genere.name;
		});
	};
	_initPlayer = (
		type,
		URL,
		Imgarr,
		results,
		video_info,
		status,
		licenseUrl,
		fairplayCertUrl,
		bids
	) => {
		var container = document.getElementById("player");

		//var language = '';
		// Replace with your Comscore Publisher ID value.17.});
		//console.log("video_info ",results);
		this.setState({
			data: results,
		});
		if (container !== null) {
			var videoInmilliSecs;
			if (results.content.duration) {
				var videoDurationArray = results.content.duration.split(":");
				videoInmilliSecs =
					videoDurationArray[0] * 60 * 60 * 1000 +
					videoDurationArray[1] * 60 * 1000 +
					videoDurationArray[2] * 1000;
			}

			// var videoMetaData = {
			//     meta_video_id: results.generalInfo._id,
			//     meta_account_id: '',
			//     meta_video_name: results.generalInfo.title,
			//     meta_video_duration: videoInmilliSecs,
			//     meta_link: video_info.src,
			//     meta_published_at: results.content.startDate,
			//     meta_updated_at: '',
			//     meta_tags: JSON.stringify([]),
			//     meta_thumbnail: '',
			// }
			// container.style.backgroundImage = `url(${ParseImgURL(
			//   Imgarr,
			//   "mdpi",
			//   "coverposter"
			// )})`;

			// console.log('content-info', this.props.contentinfo[0])
			// URL = URL.replace(
			//   "mpass-shreyaset-dd.akamaized.net",
			//   "mpass-shreyaset.akamaized.net"
			// );
			const video_type = results.generalInfo.type;
			document.getElementById("root").scrollIntoView();

			const _self = this;
			var usertype = "free";
			if(localStorage.getItem("Logged-in") === undefined && localStorage.getItem("Logged-in") === null){
				usertype = "free";
			}else if(localStorage.getItem("Logged-in") === 'true'){
				if(results && results.userType !== undefined && results.userType === ''){
					usertype = 'subscriber';
				}else if(results && results.userType !== undefined && results.userType !== ''){
					usertype = results.userType;
				}else{
					usertype = "authenticated";
				}
			}
			if (video_type === "live" || video_type === "program") {
				
				const video_player = document.getElementById("player");

				var cid = results && results._id;
				var title = results && results.generalInfo && results.generalInfo.title;
				let contentGenre = results.content.genre
					.map((gen, i) => {
						return gen.name;
					})
					.toString();
				var contentMetadata = {
					ns_st_ci: cid,
					ns_st_pr: title,
					ns_st_ep: title,
					ns_st_en: 0,
					ns_st_ge: contentGenre,
					ns_st_st: "ManoramaMax",
					ns_st_pu: "ManoramaMax",
					c4: "*null",
					c2: 7947673,
					ns_st_ddt: "*null",
					ns_st_tdt: "*null",
					// ns_st_st : null,
					c3: 4,
					c6: "*null",
					ns_st_ft: "*null",
				};
				for (var labelName in contentMetadata) {
					if (contentMetadata.hasOwnProperty(labelName)) {
						video_player.dataset[labelName] = contentMetadata[labelName];
						// console.log(video_player.dataset);
					}
				}
				var vplayer = document.getElementById("player");

				const optionsl = {
					crossorigin: "anonymous",
					cors: "anonymous",
					autoplay: true,
					preload: "auto",
					liveui: true,
				};
				var comscorePlugin;
				// console.log(video_player.ComScore)
				// console.log(player.ComScore)
				if (vplayer.ComScore) {
					// console.log("video js comscore loaded");
					// console.log('video js comscore loaded')
					comscorePlugin = vplayer.ComScore({ publisherId: "7947673" });
					// console.log(results);
				}
				var p = window.videojs(vplayer, optionsl);
				var uPacks = sessionStorage.getItem("userPacks")
					? JSON.parse(sessionStorage.getItem("userPacks"))
					: null;
				let featuresads = true;
				if (results.features) {
					featuresads = results.features.ads;
				}

				// if (results.content.adEnabled && uPacks.length <= 0) {
				if (results.content.adEnabled && featuresads && results && results.videos && results.videos.status === 'SUCCESS') {
					if (
						results.content.adConfig &&
						results.content.adConfig.vast &&
						results.content.adConfig.vast.web
					) {
						var responseUrl = results.content.adConfig.vast.web
							? results.content.adConfig.vast.web
							: "";

						let userAge, ctype, vid, pagename, tags, gender;

						pagename = window.location.pathname.split("/")[1];
						if (localStorage.getItem("dob")) {
							userAge = this.calculate_age(localStorage.getItem("dob"));
							if (userAge >= 13 && userAge <= 17) {
								userAge = "13to17yrs";
							} else if (userAge >= 18 && userAge <= 24) {
								userAge = "18to24yrs";
							} else if (userAge >= 25 && userAge <= 34) {
								userAge = "25to34yrs";
							} else if (userAge >= 35 && userAge <= 44) {
								userAge = "35to44yrs";
							} else if (userAge >= 45 && userAge <= 54) {
								userAge = "45to54yrs";
							} else if (userAge >= 55 && userAge <= 64) {
								userAge = "55to64yrs";
							} else if (userAge >= 65) {
								userAge = "65+yrs";
							} else {
								userAge = "";
							}
						} else {
							userAge = "";
						}
						if (localStorage.getItem("gender")) {
							if (
								localStorage.getItem("gender") == "M" ||
								localStorage.getItem("gender") == "m"
							) {
								gender = "male";
							} else if (
								localStorage.getItem("gender") == "F" ||
								localStorage.getItem("gender") == "f"
							) {
								gender = "female";
							}else if (
								localStorage.getItem("gender") == "O" ||
								localStorage.getItem("gender") == "o"
							) {
								gender = "others";
							} else {
								gender = "na";
							}
						} else {
							gender = "na";
						}
						if (results && results.generalInfo && results.generalInfo.type) {
							ctype = results.generalInfo.type;
						}
						// console.log(results.tags);
						if (
							results &&
							results.tags &&
							results.tags.values &&
							results.tags.values.length > 0
						) {
							tags = encodeURI(this.gettags(results.tags.values));
						}
						vid = results._id;
						var durationforad = "12-30mins";
						if (
							results &&
							results.content &&
							results.content.duration &&
							results.content.duration != ""
						) {
							var time = results.content.duration;
							var actualTime = time.split(":");
							var totalSeconds =
								+actualTime[0] * 60 * 60 + +actualTime[1] * 60 + +actualTime[2];
							var min = totalSeconds / 60;
							if (min >= 1 && min <= 5) {
								durationforad = "1-5mins";
							} else if (min >= 5 && min <= 12) {
								durationforad = "5-12mins";
							} else if (min >= 5 && min <= 12) {
								durationforad = "5-12mins";
							} else if (min >= 12 && min <= 13) {
								durationforad = "12-13mins";
							} else if (min >= 3 && min <= 90) {
								durationforad = "3-90mins";
							} else if (min >= 90) {
								durationforad = "90mins";
							} else {
								durationforad = "12-30mins";
							}
						}
						let gam_preview_id = this.querygam_preview("gam_preview");
						let firstvisit = !this.getCookie("FirstVisit") ? "Y" : "N";
						// var usertype = localStorage.getItem("Logged-in")
						// 	? "authenticated"
						// 	: "free";
						var paywall = this.props.contentinfo[0].generalInfo.isSellable
							? "Y"
							: "N";
						var genre = this.getGenre(this.props.contentinfo[0].content.genre);
						let referrer = "direct";
						if (document.referrer) {
							referrer = document.referrer.match(/:\/\/(.[^/]+)/)[1];
						}

						var addon =
							"&vid=" +
							vid +
							"&url=" +
							window.location.href +
							"&cust_params=content_type%3D" +
							ctype +
							"%26content_id%3D" +
							vid +
							"%26duration%3D" +
							durationforad +
							"%26content_language%3Dmalayalam%26usertype%3D" +
							usertype +
							"%26content_name%3D" +
							encodeURI(results.generalInfo.title) +
							"%26tags%3D" +
							tags +
							"%26content_page%3D" +
							pagename +
							"%26genre%3D" +
							genre +
							"%26consent_targeting%3DYes%26source%3D" +
							referrer +
							"%26video_watch_count%3D1" +
							+"%26page%3D" +
							"detail" +
							+"%26platform%3D" +
							"web" +
							"%26position%3DATF%26paywall%3D" +
							paywall +
							"%26firstvisit%3D" +
							firstvisit;
						if (userAge != "") {
							addon += "%26age%3D" + userAge;
						}
						if (gender != "na") {
							addon += "%26gender%3D" + gender;
						}
						if (gam_preview_id.length > 0) {
							addon += "%26gam_preview%3D" + gam_preview_id;
						}
						if(bids && bids.length > 0 && bids != ""){
							addon += "%26"+ bids[0].encodedQsParams.substr(3);
						}

						var mainAdUrl = responseUrl + addon;

						var ad_options = {
							id: "player",
							adTagUrl: mainAdUrl,
						};
						// remove kaspersky blocking
						if (window.google && window.google.ima) {
							// console.log(window.google.ima);
							window.google.ima.settings.setDisableCustomPlaybackForIOS10Plus(
								true
							);

							p.ima(ad_options);
						}
						this.createCookie();
					}
				}
				var that = this;
				let nonceLoader;
				let managerPromise;
				if (window.goog && window.goog.pal) {
					nonceLoader = new window.goog.pal.NonceLoader();
					const request = new window.goog.pal.NonceRequest();
					request.adWillAutoPlay = true;
					request.adWillPlayMuted = true;
					request.continuousPlayback = false;
					request.descriptionUrl = "https://example.com";
					request.iconsSupported = true;
					request.playerType = "Sample Player Type";
					request.playerVersion = "1.0";
					request.ppid = "Sample PPID";
					request.videoHeight = 480;
					request.videoWidth = 640;

					managerPromise = nonceLoader.loadNonceManager(request);
					managerPromise
						.then((manager) => {
							p.ready(function () {
								p.src({
									src: `${URL}&ads.paln=${manager.getNonce()}`,

									type: type,
								});
								p.play();
								
								clock.resume();
								heartbeat.resume();
								that.props.videoPlay();
							});
						})
						.catch((error) => {
							p.ready(function () {
								p.src({
									src: URL,

									type: type,
								});
								p.play();
								
								clock.resume();
								heartbeat.resume();
								that.props.videoPlay();
							});
						});
				} else {
					p.ready(function () {
						p.src({
							src: URL,

							type: type,
						});
						p.play();

						clock.resume();
						heartbeat.resume();
						that.props.videoPlay();
					});
				}

				p.on("adsready", function () {
					p.ima.addEventListener(
						window.google.ima.AdEvent.Type.CLICK,
						function () {
							// console.log(">>> ad clicked");
						}
					);
					p.ima.addEventListener(
						window.google.ima.AdEvent.Type.COMPLETE,
						function () {
							// console.log(">>> ad COMPLETE");
							p.play();
						}
					);
					p.ima.addEventListener(
						window.google.ima.AdEvent.Type.SKIPPED,
						function () {
							// console.log(">>> ad COMPLETE");
							p.play();
						}
					);

					p.ima.addEventListener(
						window.google.ima.AdEvent.Type.LOG,
						function () {
							//console.log(">>> ad LOG");
							p.play();
						}
					);
				});
				// console.log("play");
				p.on("timeupdate", function () {
					var pingtime = 30;
					// var timelimit=localStorage.getItem("wintimer")
					// if (window.timer > Number(timelimit)) {
					//   this.setState({live_pingtime : 600})
					//   pingtime = 600;
					// } else {
					//   this.setState({live_pingtime : 30})
					//   pingtime = 30;
					// }
					pingtime = Math.ceil(pingtime);

					if (_self.timer !== Math.ceil(p.currentTime())) {
						// console.log("Content ping", pingtime);
						var i = Math.ceil(p.currentTime());
						_self.timer = i;

						if (window.timer % pingtime === 0) {
							// firebaseEvents.contentPing(
							//   results,
							//   _self.contentPosition,
							//   _self.carouselPosition,
							//   _self.tabName
							// );
							lensEvents.contentPing(
								results,
								_self.contentPosition,
								_self.carouselPosition,
								_self.tabName,
								_self.contentSource,
								_self.sourceName,
								_self.completed,
								_self.studioname,
								"",
								pingtime,
								window.timer,
								"play"
							);
						}
					}
				});
				///////////////////////////////////////////////////////////////
				p.on("play", () => {
					_self.props.videoPlay();
					document.querySelector(".vjs-big-play-button").style.display = "none";
					clock.resume();
					heartbeat.resume();
					_self.hideparentalcontrol();

					if (results.content.adEnabled && uPacks.length <= 0) {
						if (
							results.content.adConfig &&
							results.content.adConfig.vast &&
							results.content.adConfig.vast.web
						) {
							// if (window.google && window.google.ima) {
							//     console.log(window.google.ima);
							//     window.google.ima.settings.setDisableCustomPlaybackForIOS10Plus(
							//       true
							//     );
							//     p.ima(ad_options);
							//   }
						}
					}
					// lensEvents.trackvideoviewedfn()
					/* Skip Introduction */
					try {
						const skipInterval = window.setInterval(function () {
							const skipIntro = that.state.skipIntro;
							if (skipIntro) {
								if (player.hasStarted_) {
									// console.log('elapsedTime', video_info.elapsedTime);
									// console.log('jumpTo', skipIntro.jumpTo);
									const video = document.querySelector("video");
									if (video) {
										const currentTime = Math.round(video.currentTime);
										const skipStartPosition = Math.round(
											skipIntro.skipStartPosition
										);
										const skipEndPosition = Math.round(
											skipIntro.skipEndPosition
										);
										const skipIntroButton =
											document.getElementById("skipIntroButton");
										// console.log('skipStartPosition', skipStartPosition, ' currentTime ', currentTime, ' skipEndPosition ', skipEndPosition )
										if (
											currentTime >= skipStartPosition &&
											currentTime <= skipEndPosition
										) {
											// console.log('currentTime ',currentTime)
											if (skipIntroButton === null) {
												let div = document.createElement("div");
												div.className = "vast-skip-button";
												div.onclick = that.skipIntroduction;
												div.id = "skipIntroButton";
												div.innerHTML = `<p class="vast-skip-button-text">${skipIntro.skipDisplay}</p>`;
												document.getElementById("player").appendChild(div);
											} else {
												skipIntroButton.classList.remove("hidden");
											}
										} else {
											if (skipIntroButton) {
												clearInterval(skipInterval);
												skipIntroButton.classList.add("hidden");
											}
										}
									}
								}
							}
						}, 1000);
					} catch (e) {
						// console.log(e);
					}

					/* /Skip Introduction */

					// document.querySelector('.vjs-big-play-button').style.display = 'none'

					// if (player.paused()) {
					// }else{
					//   console.log('play test')
					//   clock.resume();
					// }

					// console.log(status);
					if (
						results.videos.status === "ERR_USER_NOT_SUBSCRIBED" ||
						results.videos.status === "ERR_NON_LOGGED_USER"
					) {
						this.setState({
							videoStatus: results.videos.status,
							toastMessage: results.videos.status
						});

						player.pause();

						if (
							that.queryStringParse(that.props.location.search).mode !==
							undefined &&
							that.queryStringParse(that.props.location.search).tid !==
							undefined
						) {
							that.subscription(
								that.queryStringParse(that.props.location.search).mode,
								that.queryStringParse(that.props.location.search).tid
							);
						} else {
							that.subscription("", "");
						}

						//that.subscription();
					} else {
						// alert('else clasues')
						let playerDiv = document.querySelector("video");
						// let videopauseTime = parseFloat(playerDiv.currentTime) * 1000;
						let currenttime = parseInt(playerDiv.currentTime).toString();
						if (_self.state.startVideo) {
							// firebaseEvents.contentStarted(
							//   results,
							//   _self.contentPosition,
							//   _self.carouselPosition,
							//   _self.tabName
							// );
							lensEvents.viewedStarted(
								results,
								_self.contentPosition,
								_self.carouselPosition,
								_self.tabName,
								_self.contentSource,
								_self.sourceName,
								currenttime,
								_self.studioname
							);

							_self.setState({
								startVideo: false,
							});
						}

						let et = playerDiv.currentTime;
						// console.log("playerDiv",playerDiv.duration,playerDiv.ended)
						let videoInSecs1 = playerDiv.duration;
						//  console.log(et,videoInSecs1)
						let pc = parseInt((et / videoInSecs1) * 100);

						//  let completed="";
						//   if(playerDiv.ended){
						//     completed="Yes"
						//   }
						//   else
						//   {
						//     completed="No"
						//   }
						// console.log("studioname", _self.studioname);
						// let elapsedTime=video_info.elapsedTime
						// let pc=elapsedTime/duration;
						// console.log("pc",pc,elapsedTime,duration)
						lensEvents.contentPlayed(
							results,
							_self.contentPosition,
							_self.carouselPosition,
							_self.tabName,
							_self.contentSource,
							_self.sourceName,
							pc,
							_self.completed,
							_self.studioname
						);

						//videoStart++;

						// firebase.analytics().logEvent('content_played', {
						//     'content name': results.generalInfo.title,
						//     'content type': results.generalInfo.type,
						//     'content id': results.generalInfo._id,
						//     'content duration': results.content.duration,
						//     'duration played': Math.round(player.cache_.currentTime),
						//     'content language': language,
						//     'source': localStorage.getItem('source'),
						//     'source detail': localStorage.getItem('source details'),
						//     'release date': results.content.releaseDate
						// });
					}
					if (_self.isPaused) {
						_self.isPaused = false;
						_self.setState({
							isPaused: false,
						});

						that.playerUpdate(results, "resume", player);
					}
				});

				p.on("pause", () => {
					document.querySelector(".vjs-big-play-button").style.display =
						"block";
					_self.props.videoPause();
					_self.isPaused = true;
					_self.setState({
						isPaused: true,
					});
					localStorage.setItem("wintimer", window.timer + 600);
					// firebaseEvents.contentPaused(
					//   results,
					//   _self.contentPosition,
					//   _self.carouselPosition,
					//   _self.tabName
					// );

					let playerDiv = document.querySelector("video");
					// let videopauseTime = parseFloat(playerDiv.currentTime) * 1000;
					let videopauseTime = parseInt(playerDiv.currentTime);

					let videoInSecs1 = playerDiv.duration;
					let pc = Math.ceil((videopauseTime / videoInSecs1) * 100);

					if (pc == 100) {
						_self.completed = "Yes";
					}
					// let vEventData = {
					//     paused_at: videopauseTime
					// }
					lensEvents.viewedPaused(
						results,
						_self.contentPosition,
						_self.carouselPosition,
						_self.tabName,
						_self.contentSource,
						_self.sourceName,
						_self.completed,
						pc,
						videopauseTime,
						_self.studioname
					);
					// document.querySelector('.vjs-big-play-button').style.display = 'block'
					const timestamp = Math.floor(Date.now());
					let duration;
					let pd = window.timer % 30;
					duration = window.timer;
					lensEvents.contentPing(
						results,
						_self.contentPosition,
						_self.carouselPosition,
						_self.tabName,
						_self.contentSource,
						_self.sourceName,
						_self.completed,
						_self.studioname,
						pc,
						pd,
						duration,
						"pause"
					);
					// console.log('pause main',duration)
					clock.pause();
					heartbeat.pause();

					that.playerUpdate(results, "pause", player);
					// myplexAPI.updatePlayerMou(results.generalInfo._id, duration, timestamp).then(res =>{
					//   console.log(res)
					// });
				});
				p.on("ended", () => {
					var contentId;

					if (
						this.props &&
						this.props.contentinfo &&
						this.props.contentinfo[0] &&
						this.props.contentinfo[0].content
					) {
						contentId = this.props.contentinfo[0].content.nextContent;
						myplexAPI.getContentData(contentId).then((response) => {
							localStorage.setItem("autoplay", true);

							var pagename = window.location.href.split("/")[3];
							var data =
								response &&
								response.data &&
								response.data.results &&
								response.data.results[0];
							var url = `/${getURLName(data, pagename)}/detail/${data.generalInfo._id
								}/${slugify(data.generalInfo.title)}`;

							if (data.generalInfo.type == "tvepisode") {
								var beautifytitle =
									data.generalInfo.title && data.generalInfo.title.split("|");
								var t = beautifytitle[0];
								if (beautifytitle[1]) {
									t = t + beautifytitle[1];
								}

								url = `/${getURLName(data, pagename)}/detail/${data.generalInfo._id
									}/${slugify(data.globalServiceName)}/${slugify(t)}`;
							}
							this.props.history.push({ pathname: url });
						});
					} else {
						localStorage.removeItem("autoplay");
					}
					// contentId = this.props.videoId;
					// console.log(this.props.videoId);
					_self.props.videoEnded();
					// console.log(_self.props.videoEnded);
					const timestamp = Math.floor(Date.now());
					var container = document.getElementById("player");
					var y = window.videojs(container);
					// firebaseEvents.contentPlayed(
					//   results,
					//   _self.contentPosition,
					//   _self.carouselPosition,
					//   _self.tabName,
					//   _self.contentSource,
					//   _self.sourceName
					// );

					//lensEvents.viewedPlayed({}, videoMetaData);
					//lensEvents. videoEnded({}, videoMetaData);
					// console.log("mou", duration);

					that.playerUpdate(results, "stop", p);

					if (_self.state.isPPVInterval) {
						that.playerUpdate(results, "complete", p);
						// this.props.history.push(window.location.href)
						_self.isPaused = true;
						_self.setState({
							_isPaused: true,
						});
						window.setTimeout(function () {
							window.location.reload();
						}, 1000);
					}
					let duration;
					duration = window.timer;
					let tab = localStorage.getItem("tabName");
					let cTitle = localStorage.getItem("source details");
					let source = localStorage.getItem("source");
					let os = localStorage.getItem("os");
					let trackingId = localStorage.getItem("trackingId")
					let contentPosition = this.contentPosition;
					let carouselPosition = this.carouselPosition;
					const contentType = this.props.contentinfo[0].generalInfo.type;
					if (!this.contentPosition) {
						var carosuelDetTab = sessionStorage
							.getItem(this.props.match.params.Id)
							?.split("@@");

						if (carosuelDetTab && carosuelDetTab.length > 0) {
							contentPosition = carosuelDetTab[0];
							carouselPosition = parseInt(carosuelDetTab[1]);
							this.tabName = carosuelDetTab[2];
							this.contentSource = carosuelDetTab[3];
							this.sourceName = carosuelDetTab[4];
						}

					}
					if(trackingId !=="" && trackingId !== undefined && trackingId !== null){
						localStorage.setItem("trackingId","")
					}
					myplexAPI
						.updatePlayerMou(
							results.generalInfo._id,
							duration,
							timestamp,
							results.mediaSessionToken,
							tab,
							cTitle,
							source,
							contentPosition, carouselPosition, os, contentType, trackingId
						)
						.then((res) => {
							// console.log(res)
							clock.clear();
						});
					//player.destroy();
					// player.reset();

					// player.off();
				});
				/////////////////////////////////////////////////////////////////////////////////////
			} else {
				var license;

				license = licenseUrl;

				const video_player = document.getElementById("player");
				const options = {
					crossorigin: "anonymous",
					cors: "anonymous",
					// autoplay: true,
					// muted:true,
					preload: "auto",
					// "nativeControlsForTouch": true,
					flash: {
						hls: {
							withCredentials: true,
						},
					},
					// plugins:{thumbnails:{}}
				};
				var cid = results && results._id;
				var title = results && results.generalInfo && results.generalInfo.title;
				let contentGenre = results.content.genre
					.map((gen, i) => {
						return gen.name;
					})
					.toString();
				var contentMetadata = {
					ns_st_ci: cid,
					ns_st_pr: title,
					ns_st_ep: title,
					ns_st_en: 0,
					ns_st_ge: contentGenre,
					ns_st_st: "ManoramaMax",
					ns_st_pu: "ManoramaMax",
					c4: "*null",
					c2: 7947673,
					ns_st_ddt: "*null",
					ns_st_tdt: "*null",
					// ns_st_st : null,
					c3: 4,
					c6: "*null",
					ns_st_ft: "*null",
				};
				for (var labelName in contentMetadata) {
					if (contentMetadata.hasOwnProperty(labelName)) {
						video_player.dataset[labelName] = contentMetadata[labelName];
						// console.log(video_player.dataset);
					}
				}
				var player = window.videojs(video_player, options);

				var comscorePlugin;

				if (player.ComScore) {
					// console.log("video js comscore loaded");
					// console.log('video js comscore loaded')
					comscorePlugin = player.ComScore({ publisherId: "7947673" });
					// console.log(results);
				}
				// var track = document.createElement("track");
				// track.kind = "metadata";
				// track.src = this.state.thumbnailSeekPreview;
				// video_player.appendChild(track);
				var player = window.videojs(video_player, options);
				// if (localStorage.getItem("Logged-in")) {
				var uPacks = sessionStorage.getItem("userPacks")
					? JSON.parse(sessionStorage.getItem("userPacks"))
					: null;
				let featuresads = true;
				if (results.features) {
					featuresads = results.features.ads;
				}
				//console.log("results -- ",results);
				if (results.content.adEnabled && featuresads && results && results.videos && results.videos.status === 'SUCCESS') {
					if (
						results.content.adConfig &&
						results.content.adConfig.vast &&
						results.content.adConfig.vast.web
					) {
						var responseUrl = results.content.adConfig.vast.web
							? results.content.adConfig.vast.web
							: "";

						let userAge, ctype, vid, pagename, tags, gender;

						pagename = window.location.pathname.split("/")[1];
						if (localStorage.getItem("dob")) {
							userAge = this.calculate_age(localStorage.getItem("dob"));
							if (userAge >= 13 && userAge <= 17) {
								userAge = "13to17yrs";
							} else if (userAge >= 18 && userAge <= 24) {
								userAge = "18to24yrs";
							} else if (userAge >= 25 && userAge <= 34) {
								userAge = "25to34yrs";
							} else if (userAge >= 35 && userAge <= 44) {
								userAge = "35to44yrs";
							} else if (userAge >= 45 && userAge <= 54) {
								userAge = "45to54yrs";
							} else if (userAge >= 55 && userAge <= 64) {
								userAge = "55to64yrs";
							} else if (userAge >= 65) {
								userAge = "65+yrs";
							} else {
								userAge = "";
							}
						} else {
							userAge = "";
						}
						if (localStorage.getItem("gender")) {
							if (
								localStorage.getItem("gender") == "M" ||
								localStorage.getItem("gender") == "m"
							) {
								gender = "male";
							} else if (
								localStorage.getItem("gender") == "F" ||
								localStorage.getItem("gender") == "f"
							) {
								gender = "female";
							}else if (
								localStorage.getItem("gender") == "O" ||
								localStorage.getItem("gender") == "o"
							) {
								gender = "others";
							} else {
								gender = "na";
							}
						} else {
							gender = "na";
						}
						//console.log("gender ",gender);
						if (results && results.generalInfo && results.generalInfo.type) {
							ctype = results.generalInfo.type;
						}
						// console.log(results.tags);
						if (
							results &&
							results.tags &&
							results.tags.values &&
							results.tags.values.length > 0
						) {
							tags = encodeURI(this.gettags(results.tags.values));
						}
						vid = results._id;
						var durationforad = "12-30mins";
						if (
							results &&
							results.content &&
							results.content.duration &&
							results.content.duration != ""
						) {
							var time = results.content.duration;
							var actualTime = time.split(":");
							var totalSeconds =
								+actualTime[0] * 60 * 60 + +actualTime[1] * 60 + +actualTime[2];
							var min = totalSeconds / 60;
							if (min >= 1 && min <= 5) {
								durationforad = "1-5mins";
							} else if (min >= 5 && min <= 12) {
								durationforad = "5-12mins";
							} else if (min >= 5 && min <= 12) {
								durationforad = "5-12mins";
							} else if (min >= 12 && min <= 13) {
								durationforad = "12-13mins";
							} else if (min >= 3 && min <= 90) {
								durationforad = "3-90mins";
							} else if (min >= 90) {
								durationforad = "90mins+";
							} else {
								durationforad = "12-30mins";
							}
						}

						let gam_preview_id = this.querygam_preview("gam_preview");
						let firstvisit = !this.getCookie("FirstVisit") ? "Y" : "N";
						// var usertype = localStorage.getItem("Logged-in")
						// 	? "authenticated"
						// 	: "free";
						var paywall = this.props.contentinfo[0].generalInfo.isSellable
							? "Y"
							: "N";
						var genre = this.getGenre(this.props.contentinfo[0].content.genre);
						let referrer = "direct";
						if (document.referrer) {
							referrer = document.referrer.match(/:\/\/(.[^/]+)/)[1];
						}

						var addon =
							"&vid=" +
							vid +
							"&url=" +
							window.location.href +
							"&cust_params=content_type%3D" +
							ctype +
							"%26content_id%3D" +
							vid +
							"%26duration%3D" +
							durationforad +
							"%26content_language%3Dmalayalam%26usertype%3D" +
							usertype +"%26content_name%3D" +
							encodeURI(results.generalInfo.title) +
							"%26tags%3D" +
							tags +
							"%26content_page%3D" +
							pagename +
							"%26genre%3D" +
							genre +
							"%26consent_targeting%3DYes%26source%3D" +
							referrer +
							"%26video_watch_count%3D1" +
							"%26page%3D" +
							"detail" +
							"%26platform%3D" +
							"web" +
							"%26position%3DATF%26paywall%3D" +
							paywall +
							"%26firstvisit%3D" +
							firstvisit;
						if (userAge != "") {
							addon += "%26age%3D" + userAge;
						}
						if (gender != "na") {
							addon += "%26gender%3D" + gender;
						}
						if (gam_preview_id.length > 0) {
							addon += "%26gam_preview%3D" + gam_preview_id;
						}
						if (
							this.props.contentinfo &&
							this.props.contentinfo[0] &&
							this.props.contentinfo[0].generalInfo &&
							this.props.contentinfo[0].generalInfo.type == "tvepisode"
						) {
							addon +=
								"%26episode%3D" +
								this.props.contentinfo[0].content.siblingOrder;
						}
						if(bids && bids.length > 0 && bids != ""){
							addon += "%26" + bids[0].encodedQsParams.substr(3);
						}
						//console.log("addon -- ",addon);
						// responseUrl = "https://pubads.g.doubleclick.net/gampad/ads?iu=/21830968352/mmax/video/programs&description_url=http%3A%2F%2Fwww.manoramamax.com&tfcd=0&npa=0&sz=640x480&ciu_szs=fluid,1x1,320x50,320x100,336x280,468x60,728x90,970x90,970x250,990x90&gdfp_req=1&output=vast&unviewed_position_start=1&env=vp&impl=&cmsid=2577598&ad_rule=1&correlator=[timestamp]";
						responseUrl = responseUrl.replace(
							"http%3A%2F%2Fwww.manoramamax.com",
							window.document.location.href
						);
						var sizes = isMobile
							? "fluid,1x1,320x50,320x100,336x280,300x250"
							: "fluid,1x1,728x90,970x90,970x250,990x90";

						responseUrl = responseUrl.replace(
							"ciu_szs=fluid,1x1,320x50,320x100,336x280,468x60,728x90,970x90,970x250,990x90",
							"ciu_szs=" + sizes
						);

						var mainAdUrl = responseUrl + addon;

						// var mainAdUrl = "https://pubads.g.doubleclick.net/gampad/ads?iu=/21775744923/external/vmap_ad_samples&sz=640x480&cust_params=sample_ar%3Dpreonly&ciu_szs=300x250%2C728x90&gdfp_req=1&ad_rule=1&output=vmap&unviewed_position_start=1&env=vp&impl=s&correlator=";
						// var mainAdUrl ="https://pubads.g.doubleclick.net/gampad/ads?iu=/21830968352/MMAX_VCMS_AD_PRE_MID_POSTROLL&description_url=http%3A%2F%2Fwww.manoramamax.com&tfcd=0&npa=0&sz=400x300%7C640x480&ciu_szs=1x1&gdfp_req=1&output=vast&unviewed_position_start=1&env=vp&impl=&cmsid=2577598&ad_rule=1&correlator=[timestamp]";
						//console.log("DD ",mainAdUrl);
						var ad_options = {
							id: "player",

							adTagUrl: mainAdUrl,
						};
						// remove kaspersky blocking

						if (window.google && window.google.ima) {
							window.google.ima.settings.setDisableCustomPlaybackForIOS10Plus(
								true
							);
							let request = {};
							request.omidAccessModeRules = {};
							request.omidAccessModeRules[
								window.google.ima.OmidVerificationVendor.GOOGLE
							] = window.google.ima.OmidAccessMode.FULL;
							request.omidAccessModeRules[
								window.google.ima.OmidVerificationVendor.OTHER
							] = window.google.ima.OmidAccessMode.DOMAIN;
							// var adsRequest = new window.google.ima.AdsRequest();
							// // var adsLoader= adsLoader = new window.google.ima.AdsLoader(player);
							// // adsRequest.adTagUrl = mainAdUrl;

							// adsRequest.setAdWillAutoPlay(true);
							// adsRequest.setAdWillPlayMuted(true);
							// adsLoader.requestAds(adsRequest);

							player.ima(ad_options);

							//player.ima.addEventListener(window.google.ima.AdEvent.Type.LOADED, this.onAdEvent);
						}
						this.createCookie();
					}
				}

				// }

				// var comscorePlugin;
				// // console.log(player.ComScore)
				// if (player.ComScore) {
				//   // console.log('video js comscore loaded')
				//   comscorePlugin = player.ComScore({ publisherId: "7947673" });
				// }
				{
					player.nuevo &&
						player.nuevo({
							buttonRewind: true,
							buttonForward: true,
							// settingsButton: false,
							contextMenu: false,
							qualityMenu: true,
							shareMenu: false,
						});
				}
				player.hotkeys({
					volumeStep: 0.1,
					seekStep: 5,
					alwaysCaptureHotkeys: true,
				});

				// player.httpSourceSelector();

				//  player.nuevo({ "qualityMenu": true });

				var that = this;
				let playerDiv = document.querySelector("video");
				if (playerDiv.ended) {
					this.completed = "Yes";
				} else {
					this.completed = "No";
				}
				player.eme();
				// player.nuevo({
				//     slideImage: '/videojs/slides/demo_slide.jpg',
				// });
				var value = "";
				if (that.state.thumbnailSeekPreview !== "") {
					var temp = that.state.thumbnailSeekPreview.split("/");
					// console.log(temp);
					temp.pop();

					//value = that.state.thumbnailSeekPreview.replace(temp[5], "");
					value = temp.join("/");
					// console.log('basepath', value)
				} else {
					// console.log('basepath', value)
				}
				player.thumbnails &&
					player.thumbnails({ width: 100, height: 300, basePath: value + "/" });

				var contentPlayer = document.getElementById("player_html5_api");
				if (contentPlayer) {
					if (
						(navigator.userAgent.match(/iPad/i) ||
							navigator.userAgent.match(/Android/i)) &&
						contentPlayer.hasAttribute("controls")
					) {
						contentPlayer.removeAttribute("controls");
					}
					var startEvent = "click";
					if (
						navigator.userAgent.match(/iPhone/i) ||
						navigator.userAgent.match(/iPad/i) ||
						navigator.userAgent.match(/Android/i)
					) {
						startEvent = "touchend";
					}
					player.on(startEvent, function () {
						// player.ima.initializeAdDisplayContainer();
					});
				}

				player.on("timeupdate", function () {
					var pingtime = 12;
					// console.log(results.skipConfig);

					// console.log(player.duration());
					if (results.content.duration) {
						// var a = results.content.duration.split(':'); // split it at the colons
						// var seconds = (+a[0]) * 60 * 60 + (+a[1]) * 60 + (+a[2]);
						// var seconds = Math.ceil(player.duration());
						// // console.log(seconds);
						// if (seconds <= 3600) {
						//   pingtime = seconds / 3;
						// } else {
						//   pingtime = seconds / 10;
						// }
						var timelimit = localStorage.getItem("wintimer");

						if (window.timer > Number(timelimit)) {
							// console.log("wintimer",timelimit,window.timer)
							pingtime = 300;
						} else {
							// this.setState({content_pingtime : 25})
							pingtime = 15;
						}
						pingtime = Math.ceil(pingtime);
					}

					if (_self.timer !== Math.ceil(player.currentTime())) {
						var i = Math.ceil(player.currentTime());
						_self.timer = i;
						// _self.skipButtons(results.skipConfig);
						if (window.timer % pingtime === 0) {
							let playerDiv = document.querySelector("video");
							let et = playerDiv.currentTime;
							let videoInSecs1 = playerDiv.duration;
							let pc = parseInt((et / videoInSecs1) * 100);
							// console.log("Pc",pc,videoInSecs1,et)
							// console.log("Content ping", pingtime);
							// firebaseEvents.contentPing(
							//   results,
							//   _self.contentPosition,
							//   _self.carouselPosition,
							//   _self.tabName
							// );
							lensEvents.contentPing(
								results,
								_self.contentPosition,
								_self.carouselPosition,
								_self.tabName,
								_self.contentSource,
								_self.sourceName,
								_self.completed,
								_self.studioname,
								pc,
								pingtime,
								window.timer,
								"play"
							);
						}
					}
				});

				player.on("adsready", function () {
					console.log("Player ad ready");
					player.ima.addEventListener(
						window.google.ima.AdEvent.Type.CLICK,
						function () {
							var ad_id = player.ima.getAdsManager().l.j.adId;
							//  console.log(">>> ad clicked");
							// if (localStorage.getItem("Logged-in")) {
							let contentGenre = results.content.genre
								.map((gen, i) => {
									return gen.name;
								})
								.toString();
							var adClickData = {
								"content type": results.generalInfo.type,
								"content id": results.generalInfo._id,
								"content name": results.generalInfo.title,
								"series name": "",
								"content language":
									results.content.language.length > 0
										? results.content.language[0]
										: "",
								"content genre": contentGenre,
								source: "",
								"source details": "",
								"content position": _self.contentPosition,
								"carousel position": _self.carouselPosition,
								tab: _self.tabName,
								"content model":
									results.generalInfo.isSellable === true ? "Paid" : "Free",
								"ad type": "",
								"skippable ad": "yes",
								"skip status": "",
								"duration played": "",
								"total ad duration": "",
								ad_status: "ended",
								ad_id: ad_id,
							};

							// firebaseEvents.adClicked(adClickData);

							lensEvents.adClicked(
								results,
								_self.contentPosition,
								_self.carouselPosition,
								_self.tabName,
								_self.contentSource,
								_self.sourceName,
								ad_id
							);
							// }
						}
					);
					var that = this;
					player.ima.addEventListener(
						window.google.ima.AdEvent.Type.COMPLETE,
						function () {							
							//console.log(">>> ad COMPLETE");
							//player.play();
							
							// var ad_id = player.ima.getAdsManager().l.j.adId;

							// if (localStorage.getItem("Logged-in")) {
							let contentGenre = results.content.genre
								.map((gen, i) => {
									return gen.name;
								})
								.toString();

							var adCompleteData = {
								"content type": results.generalInfo.type,
								"content id": results.generalInfo._id,
								"content name": results.generalInfo.title,
								"series name": "",
								"content language":
									results.content.language.length > 0
										? results.content.language[0]
										: "",
								"content genre": contentGenre,
								source: "",
								"source details": "",
								"content position": _self.contentPosition,
								"carousel position": _self.carouselPosition,
								tab: _self.tabName,
								"content model":
									results.generalInfo.isSellable === true ? "Paid" : "Free",
								"ad type": "",
								"skippable ad": "yes",
								"skip status": "",
								"duration played": "",
								"total ad duration": "",
								ad_status: "ended",
								// ad_id: ad_id,
							};

							// firebaseEvents.adComplete(adCompleteData);

							lensEvents.adEnded(
								results,
								_self.contentPosition,
								_self.carouselPosition,
								_self.tabName,
								_self.contentSource,
								_self.sourceName,
								""
							);
							// }
							player.play();
						}
					);
					player.ima.addEventListener(
						window.google.ima.AdEvent.Type.CLICK,
						function () {
							var element = document.getElementById(
								"player_ima-play-pause-div"
							);
							if (element) {
								element.click();
								// element.classList.add("ima-paused");
							}
						}
					);
					player.ima.addEventListener(
						window.google.ima.AdEvent.Type.PAUSED,
						function () {
							// console.log(">>> ad PAUSED");
							var ad_id = player.ima.getAdsManager().l.j.adId;

							// if (localStorage.getItem("Logged-in")) {
							// console.log(results, "myresultssssssssss");
							let contentGenre = results.content.genre
								.map((gen, i) => {
									return gen.name;
								})
								.toString();
							var adPauedData = {
								"content type": results.generalInfo.type,
								"content id": results.generalInfo._id,
								"content name": results.generalInfo.title,
								"series name": "",
								"content language":
									results.content.language.length > 0
										? results.content.language[0]
										: "",
								"content genre": contentGenre,
								source: "",
								"source details": "",
								"content position": _self.contentPosition,
								"carousel position": _self.carouselPosition,
								tab: _self.tabName,
								"content model":
									results.generalInfo.isSellable === true ? "Paid" : "Free",
								"ad type": "",
								"skippable ad": "yes",
								"skip status": "",
								"duration played": "",
								"total ad duration": "",
								ad_status: "started",
								ad_id: ad_id,
							};

							lensEvents.adPaused(
								results,
								_self.contentPosition,
								_self.carouselPosition,
								_self.tabName,
								_self.contentSource,
								_self.sourceName,
								ad_id
							);
							// }
						}
					);
					player.ima.addEventListener(
						window.google.ima.AdEvent.Type.STARTED,
						function () {
							console.log(">>> ad STARTED");
							player.pause();
							//console.log(" player.ima.getAdsManager() ", player.ima.getAdsManager())
							var ad_id = player.ima.getAdsManager() && player.ima.getAdsManager().l.j.adId;
							//  console.log("adid",player.ima.getAdsManager().l.j.adId);
							// console.log(player);

							
							// console.log("adId",window.google.ima.AdEvent.getAD());
							// window.lens.publisher.trackAd("Viewed Promo Channel", {
							//     'channel': results.generalInfo.type,
							//     'title': results.generalInfo.title
							// });
							// if (localStorage.getItem("Logged-in")) {
							// console.log(results, "myresultssssssssss");
							let contentGenre = results.content.genre
								.map((gen, i) => {
									return gen.name;
								})
								.toString();
							var adStartData = {
								"content type": results.generalInfo.type,
								"content id": results.generalInfo._id,
								"content name": results.generalInfo.title,
								"series name": "",
								"content language":
									results.content.language.length > 0
										? results.content.language[0]
										: "",
								"content genre": contentGenre,
								source: "",
								"source details": "",
								"content position": _self.contentPosition
									? _self.contentPosition
									: null,
								"carousel position": _self.carouselPosition,
								tab: _self.tabName,
								"content model":
									results.generalInfo.isSellable === true ? "Paid" : "Free",
								"ad type": "",
								"skippable ad": "yes",
								"skip status": "",
								"duration played": "",
								"total ad duration": "",
								ad_status: "clicked",
								ad_id: ad_id,
							};

							// firebaseEvents.adStart(adStartData);

							lensEvents.adStart(
								results,
								_self.contentPosition,
								_self.carouselPosition,
								_self.tabName,
								_self.contentSource,
								_self.sourceName,
								ad_id
							);
							// }
						}
					);
					player.ima.addEventListener(
						window.google.ima.AdEvent.Type.SKIPPED,
						function () {
							// console.log(">>> ad SKIPPED");
							player.play();
							var ad_id = player.ima.getAdsManager().l.j.adId;
							let contentGenre = results.content.genre
								.map((gen, i) => {
									return gen.name;
								})
								.toString();

							// var addSkippedData = {
							//   "content type": results.generalInfo.type,
							//   "content id": results.generalInfo._id,
							//   "content name": results.generalInfo.title,
							//   "series name": "",
							//   "content language":
							//     results.content.language.length > 0
							//       ? results.content.language[0]
							//       : "",
							//   "content genre": contentGenre,
							//   source: "",
							//   "source details": "",
							//   "content position": _self.contentPosition,
							//   "carousel position": _self.carouselPosition,
							//   tab: _self.tabName,
							//   "content model":
							//     results.generalInfo.isSellable === true ? "Paid" : "Free",
							//   "ad type": "",
							//   "skippable ad": "yes",
							//   "skip status": "",
							//   "duration played": "",
							//   "total ad duration": "",
							//   ad_status: "skipped",
							//   "ad_id": ad_id,
							// };
							// firebaseEvents.adSkipped(addSkippedData);
							// let adEventData = {
							//     ad_id: '',
							//     ad_duration: '',
							//     ad_type: '',
							//     ad_title: '',
							//     ad_url: '',
							// };
							lensEvents.adSkipped(
								results,
								_self.contentPosition,
								_self.carouselPosition,
								_self.tabName,
								_self.contentSource,
								_self.sourceName,
								ad_id
							);
							
						}
					);
					player.ima.addEventListener(
						window.google.ima.AdEvent.Type.MIDPOINT,
						function () {
							// console.log(">>> ad MIDPOINT");
						}
					);
					player.ima.addEventListener(
						window.google.ima.AdEvent.Type.RESUMED,
						function () {
							// console.log(">>> ad RESUMED");
						}
					);
				});
				/* eslint-disable */
				var base64DecodeUint8Array = function (a) {
					var b = window.atob(a),
						c = b.length,
						d = new Uint8Array(new ArrayBuffer(c));
					for (var i = 0; i < c; i++) d[i] = b.charCodeAt(i);
					return d;
				};
				var base64EncodeUint8Array = function (a) {
					for (
						var d,
						e,
						f,
						g,
						h,
						i,
						j,
						b =
							"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
						c = "",
						k = 0;
						k < a.length;

					)
						(d = a[k++]),
							(e = k < a.length ? a[k++] : Number.NaN),
							(f = k < a.length ? a[k++] : Number.NaN),
							(g = d >> 2),
							(h = ((3 & d) << 4) | (e >> 4)),
							(i = ((15 & e) << 2) | (f >> 6)),
							(j = 63 & f),
							isNaN(e) ? (i = j = 64) : isNaN(f) && (j = 64),
							(c += b.charAt(g) + b.charAt(h) + b.charAt(i) + b.charAt(j));
					return c;
				};
				var arrayToString = function (a) {
					var b = new Uint16Array(a.buffer);
					return String.fromCharCode.apply(null, b);
				};
				player.ready(() => {
					console.log("Player Ready");
					// if (
					//   results.generalInfo.type === "news" ||
					//   localStorage.getItem("autoplay")
					// ) {
					if (URL !== "/static/media/blank_video.6ddef010.mp4") {
						//console.log("testplay");
						canAutoplay
							.video({ timeout: 100, muted: true })
							.then(function (response) {
								//console.log("video_info ",video_info,"results ",results);
								let elapsedTime = video_info.elapsedTime;
								const video_type = results.generalInfo.type;
								//console.log("video_type : ",video_type);
								//console.log("elapsedTime ",elapsedTime);
								if (response.result === false) {
									// Unmuted autoplay is not allowed.
									player.muted(true);
									if(elapsedTime == 0 && (video_type !== "live" && video_type !== "news" && video_type !== "musicvideo")){										
										_self.tobaccoImageDispaly();
									}									
									player.play();
								} else {
									if(elapsedTime == 0 && (video_type !== "live" && video_type !== "news" && video_type !== "musicvideo")){
										_self.tobaccoImageDispaly();
									}
									// Unmuted autoplay is allowed.
									player.play();
									// player.muted(true);
									// player.autoplay(true);
									// autoplayRequiresMute = false;
									// initPlayer();
								}
								var video = document.querySelector("video");
								//const video_type = results.generalInfo.type;
								//let elapsedTime = video_info.elapsedTime;
								// console.log(video_type);
								if (video_type !== "live" && video_type !== "program") {
									const completed = Math.round(
										(video.currentTime / video.duration) * 100
									);
									// console.log('completed', completed)
									// When used watched 100% then we are playing video starting onWords
									if (99 < completed) {
										elapsedTime = 0;
									}
									if (
										Math.round(elapsedTime) < Math.round(video.duration) &&
										elapsedTime != 0
									) {
										// console.log("elapsedTime",elapsedTime);

										video.currentTime = elapsedTime;
									}
								}
							});

						// var promise = player.play();
						// // console.log(promise);
						// if (promise !== undefined) {
						//   promise
						//     .then(function () {
						//       //  player.muted(false);
						//       // player.muted(true);
						//       player.play();
						//       // window.addEventListener('mousemove', (event) => {
						//       //   console.log(event)
						//       //   player.muted(false);

						//       // });

						//       // document.querySelector('.vjs-mute-control').click()
						//       // setInterval( document.querySelector('.vjs-mute-control').click(), 5000);

						//       // document.querySelector('.vjs-paused').click();
						//       // player.play();
						//     })
						//     .catch(function (error) {
						//       // Autoplay was prevented.
						//       // document.querySelector('.vjs-paused').click();
						//       document.getElementById("audiosection").style.display =
						//         "block";
						//        player.muted(true);
						//       player.play();
						//       // console.log("error", error);
						//     });
						// }
					}
					//   console.log(URL);
					// }
					document
						.querySelector(".vjs-forward-control")
						.addEventListener("click", this._captureforward);
					document
						.querySelector(".vjs-rewind-control")
						.addEventListener("click", this._capturerewind);
					document
						.querySelector(".vjs-progress-holder")
						.addEventListener("mouseover", this._captureSlider);
					// document
					// .querySelector(".vjs-slider")
					// .addEventListener("click", this._captureSlider1);
					document
						.querySelector(".vjs-progress-holder")
						.addEventListener("mouseup", this._captureSlider1);

					// const parentControl = document.getElementById("parentControl");

					// if (parentControl) {
					//   if (results.videos.status === "ERR_USER_NOT_SUBSCRIBED") {
					//     // var parentControl = document.getElementById("parentControl");
					//     parentControl.classList.add("subscribeuser");
					//     parentControl.innerHTML =
					//       "Subscribe to watch all premium content";
					//   }
					//   //   console.log(container);
					//   document.getElementById("player").append(parentControl);
					// }

					//  // Quick and useful if only a few contiguous quality levels
					//  var labelsArray = [ 'High', 'Medium', 'Low' ];

					//  // Useful if you need to specify labels in a sparce list
					//  var labelsObject =  { 0: 'High', 8: 'Medium', 16: 'Low', 24: 'Super Low' };

					//  player.maxQualitySelector({
					//      'labels': labelsArray | labelsObject,
					//      'filterDuplicates': false,
					//      'index': 8,
					//      //'showBitrates': true,
					//      //'filterDuplicateHeights': false,
					//      'displayMode': 2, //0 = Both (Includes both the resolution, in height, and the quality marketing name), 1 = Resolution (Include just the resolution, in height), 2 = Name (Include just the quality marketing name)
					//      'maxHeight': 1080,
					//      'minHeight': 360,
					//      //'disableAuto':true,
					//  });

					player.src({
						src: URL,
						// src : blank_video,
						type: type,
						// src: "/127573.hd1.mp4",
						// type: "video/mp4",
						keySystems: {
							"com.widevine.alpha": {
								url: license,
							},

							// 'com.apple.fps.1_0': {
							//     certificateUri: fairplayCertUrl,
							//     licenseUri: license
							// },
							"com.apple.fps.1_0": {
								certificateUri: fairplayCertUrl,

								getContentId: function (emeOptions, initData) {
									var contentId = arrayToString(initData);

									if (contentId.indexOf("skd://") > -1)
										return contentId.split("skd://")[1].substr(0, 32);

									throw "Invalid Content ID format. The format of the Content ID must be the following: skd://xxx where xxx is the Key ID in hex format.";
								},

								getLicense: function (
									emeOptions,
									contentId,
									keyMessage,
									callback
								) {
									var data =
										"spc=" +
										base64EncodeUint8Array(keyMessage) +
										"&assetId=" +
										contentId;
									window.jQuery.ajax({
										url: license,
										type: "POST",
										data: data,
										// If you are using proxy, please, remove 'headers' object.
										// headers: {
										//     'customdata': 'your base64 encoded Authentication XML here that contains FP policies.'
										// },
										contentType: "application/x-www-form-urlencoded",
										success: function (result) {
											// console.log(result);
											callback(null, base64DecodeUint8Array(result));
										},
										error: function (err) {
											callback(err);
										},
									});
								},
							},
						},

						// 'com.microsoft.playready': {
						//     serverURL: URL_LICENCEDRM(this.props.videoId)
						// }
						// poster: ParseImgURL(Imgarr, "mdpi", "coverposter")
					});

					// player.on("pause", ()=> {
					//   console.log("pause");

					//   //that.playerupdate(data,pause)
					// });
					// player.onplay
					// player.on()

					// player.seekButtons({
					//     forward: 30,
					//     back: 30
					// });

					player.on("play", () => {
						if(this.tobaccoStripShowAfterContentComplete && this.tobaccoStripShowAfterContentComplete === true){
							_self.tobaccoImageDispaly();

						}
						_self.props.videoPlay();
						// player.muted(false);
						document.querySelector(".vjs-big-play-button").style.display =
							"none";

						document.getElementsByClassName("vjs-mute-control") &&
							document
								.getElementsByClassName("vjs-mute-control")[0]
								.addEventListener("click", this.playermute);
						clock.resume();
						heartbeat.resume();
						_self.hideparentalcontrol();

						if (results.content.adEnabled && uPacks.length <= 0) {
							if (
								results.content.adConfig &&
								results.content.adConfig.vast &&
								results.content.adConfig.vast.web
							) {
								// if (window.google && window.google.ima) {
								//     console.log(window.google.ima);
								//     window.google.ima.settings.setDisableCustomPlaybackForIOS10Plus(
								//       true
								//     );
								//     p.ima(ad_options);
								//   }
							}
						}
						// lensEvents.trackvideoviewedfn()
						/* Skip Introduction */
						try {
							const skipInterval = window.setInterval(function () {
								const skipIntro = that.state.skipIntro;
								if (skipIntro) {
									if (player.hasStarted_) {
										// console.log('elapsedTime', video_info.elapsedTime);
										// console.log('jumpTo', skipIntro.jumpTo);
										const video = document.querySelector("video");
										if (video) {
											const currentTime = Math.round(video.currentTime);
											const skipStartPosition = Math.round(
												skipIntro.skipStartPosition
											);
											const skipEndPosition = Math.round(
												skipIntro.skipEndPosition
											);
											const skipIntroButton =
												document.getElementById("skipIntroButton");
											// console.log('skipStartPosition', skipStartPosition, ' currentTime ', currentTime, ' skipEndPosition ', skipEndPosition )
											if (
												currentTime >= skipStartPosition &&
												currentTime <= skipEndPosition
											) {
												// console.log('currentTime ',currentTime)
												if (skipIntroButton === null) {
													let div = document.createElement("div");
													div.className = "vast-skip-button";
													div.onclick = that.skipIntroduction;
													div.id = "skipIntroButton";
													div.innerHTML = `<p class="vast-skip-button-text">${skipIntro.skipDisplay}</p>`;
													document.getElementById("player").appendChild(div);
												} else {
													skipIntroButton.classList.remove("hidden");
												}
											} else {
												if (skipIntroButton) {
													clearInterval(skipInterval);
													skipIntroButton.classList.add("hidden");
												}
											}
										}
									}
								}
							}, 1000);
						} catch (e) {
							//  console.log(e);
						}

						/* /Skip Introduction */

						// document.querySelector('.vjs-big-play-button').style.display = 'none'

						// if (player.paused()) {
						// }else{
						//   console.log('play test')
						//   clock.resume();
						// }

						if (_self.isPaused) {
							_self.isPaused = false;
							_self.setState({
								isPaused: false,
							});
							// console.log('resume')
							that.playerUpdate(results, "resume", player);
						}
						// console.log(status);
						if (
							results.videos.status === "ERR_USER_NOT_SUBSCRIBED" ||
							results.videos.status === "ERR_NON_LOGGED_USER"
						) {
							this.setState({
								videoStatus: results.videos.status,
								toastMessage : results.videos.message
							});

							player.pause();

							if (
								that.queryStringParse(that.props.location.search).mode !==
								undefined &&
								that.queryStringParse(that.props.location.search).tid !==
								undefined
							) {
								that.subscription(
									that.queryStringParse(that.props.location.search).mode,
									that.queryStringParse(that.props.location.search).tid
								);
							} else {
								that.subscription("", "");
							}

							//that.subscription();
						} else {
							// alert('else clasues')
							let playerDiv = document.querySelector("video");
							// let videopauseTime = parseFloat(playerDiv.currentTime) * 1000;
							let currenttime = parseInt(playerDiv.currentTime).toString();
							if (_self.state.startVideo) {
								// firebaseEvents.contentStarted(
								//   results,
								//   _self.contentPosition,
								//   _self.carouselPosition,
								//   _self.tabName
								// );
								lensEvents.viewedStarted(
									results,
									_self.contentPosition,
									_self.carouselPosition,
									_self.tabName,
									_self.contentSource,
									_self.sourceName,
									currenttime,
									_self.studioname
								);

								_self.setState({
									startVideo: false,
								});
							}

							let et = playerDiv.currentTime;
							// console.log("playerDiv",playerDiv.duration,playerDiv.ended)
							let videoInSecs1 = playerDiv.duration;
							//  console.log(et,videoInSecs1)
							let pc = parseInt((et / videoInSecs1) * 100);

							//  let completed="";
							//   if(playerDiv.ended){
							//     completed="Yes"
							//   }
							//   else
							//   {
							//     completed="No"
							//   }
							// console.log("studioname", _self.studioname);
							// let elapsedTime=video_info.elapsedTime
							// let pc=elapsedTime/duration;
							// console.log("pc",pc,elapsedTime,duration)
							lensEvents.contentPlayed(
								results,
								_self.contentPosition,
								_self.carouselPosition,
								_self.tabName,
								_self.contentSource,
								_self.sourceName,
								pc,
								_self.completed,
								_self.studioname
							);

							//videoStart++;

							// firebase.analytics().logEvent('content_played', {
							//     'content name': results.generalInfo.title,
							//     'content type': results.generalInfo.type,
							//     'content id': results.generalInfo._id,
							//     'content duration': results.content.duration,
							//     'duration played': Math.round(player.cache_.currentTime),
							//     'content language': language,
							//     'source': localStorage.getItem('source'),
							//     'source detail': localStorage.getItem('source details'),
							//     'release date': results.content.releaseDate
							// });
						}
					});
					player.on('loadeddata', () => {
						// console.log("showSubtitle ",showSubtitleSafari.current);
						// console.log("showSubtitleURl ",subtitleUrlSafari.current);
						if(isSafari && this.props &&
							this.props.contentinfo &&
							this.props.contentinfo[0] &&
							this.props.contentinfo[0].subtitles &&
							this.props.contentinfo[0].subtitles.values.length > 0 ){
							let captionOption = {
								kind: 'captions',
								srclang: 'en',
								label: 'English',
								default : true,
								mode:'showing',
								src: this.props.contentinfo[0].subtitles.values[0].link_sub.replace(
									".srt",".vtt")
							  };
							  //console.log("captionOption ",captionOption);
							  player.addRemoteTextTrack(captionOption);  // palyer does not load caption
						}
						//addScript( callback );
					});
					player.on("pause", () => {
						document.querySelector(".vjs-big-play-button").style.display =
							"block";
						_self.props.videoPause();
						_self.isPaused = true;
						_self.setState({
							isPaused: true,
						});

						//console.log("wintimer",window.timer+600)

						// firebaseEvents.contentPaused(
						//   results,
						//   _self.contentPosition,
						//   _self.carouselPosition,
						//   _self.tabName
						// );

						let playerDiv = document.querySelector("video");
						// let videopauseTime = parseFloat(playerDiv.currentTime) * 1000;
						let videopauseTime = parseInt(playerDiv.currentTime);

						let videoInSecs1 = playerDiv.duration;
						let pc = Math.ceil((videopauseTime / videoInSecs1) * 100);

						if (pc == 100) {
							_self.completed = "Yes";
						}
						// let vEventData = {
						//     paused_at: videopauseTime
						// }
						lensEvents.viewedPaused(
							results,
							_self.contentPosition,
							_self.carouselPosition,
							_self.tabName,
							_self.contentSource,
							_self.sourceName,
							_self.completed,
							pc,
							videopauseTime,
							_self.studioname
						);
						let pd;
						if (window.timer > 600) {
							pd = (window.timer - 600) % 300;
						} else {
							pd = window.timer % 15;
						}
						lensEvents.contentPing(
							results,
							_self.contentPosition,
							_self.carouselPosition,
							_self.tabName,
							_self.contentSource,
							_self.sourceName,
							_self.completed,
							_self.studioname,
							pc,
							pd,
							window.timer,
							"pause"
						);
						localStorage.setItem("wintimer", window.timer + 600);
						// document.querySelector('.vjs-big-play-button').style.display = 'block'
						const timestamp = Math.floor(Date.now());
						let duration;
						duration = window.timer;
						// console.log('pause main',duration)
						clock.pause();
						heartbeat.pause();
						//console.log(results);
						that.playerUpdate(results, "pause", player);
						// myplexAPI.updatePlayerMou(results.generalInfo._id, duration, timestamp).then(res =>{
						//   console.log(res)
						// });
					});
					player.on("ended", () => {
						console.log("Player Ended")
						var contentId;

						if (
							this.props &&
							this.props.contentinfo &&
							this.props.contentinfo[0] &&
							this.props.contentinfo[0].content && this.props.contentinfo[0].content.nextContent
						) {
							contentId = this.props.contentinfo[0].content.nextContent;

							myplexAPI.getContentData(contentId).then((response) => {
								localStorage.setItem("autoplay", true);

								var pagename = window.location.href.split("/")[3];
								var data =
									response &&
									response.data &&
									response.data.results &&
									response.data.results[0];
								var url = `/${getURLName(data, pagename)}/detail/${data.generalInfo._id
									}/${slugify(data.generalInfo.title)}`;

								if (data.generalInfo.type == "tvepisode") {
									var beautifytitle =
										data.generalInfo.title && data.generalInfo.title.split("|");
									var t = beautifytitle[0];
									if (beautifytitle[1]) {
										t = t + beautifytitle[1];
									}

									url = `/${getURLName(data, pagename)}/detail/${data.generalInfo._id
										}/${slugify(data.globalServiceName)}/${slugify(t)}`;
								}
								this.props.history.push({ pathname: url });
							});
						} else {
							
							localStorage.removeItem("autoplay");
						}
						this.tobaccoStripShowAfterContentComplete = true;
						// contentId = this.props.videoId;
						// console.log(this.props.videoId);
						_self.props.videoEnded();
						// console.log(_self.props.videoEnded);
						const timestamp = this.state.mouTimestamp ? this.state.mouTimestamp : Math.floor(Date.now());
						var container = document.getElementById("player");
						var y = window.videojs(container);
						// firebaseEvents.contentPlayed(
						//   results,
						//   _self.contentPosition,
						//   _self.carouselPosition,
						//   _self.tabName,
						//   _self.contentSource,
						//   _self.sourceName
						// );

						//lensEvents.viewedPlayed({}, videoMetaData);
						//lensEvents. videoEnded({}, videoMetaData);
						// console.log("mou", duration);
						// that.playerUpdate(results, "delete", player);
						that.playerUpdate(results, "stop", player);
						that.playerUpdate(results, "complete", player);
						that.playerUpdate(results, "delete", player);
						//  that.playerUpdate(results, "stop", player);
						if (_self.state.isPPVInterval) {
							that.playerUpdate(results, "complete", player);
							// this.props.history.push(window.location.href)
							_self.isPaused = true;
							_self.setState({
								_isPaused: true,
							});
							window.setTimeout(function () {
								window.location.reload();
							}, 1000);
						}
						let duration;
						duration = window.timer;
						let tab = localStorage.getItem("tabName");
						let cTitle = localStorage.getItem("source details");
						let source = localStorage.getItem("source");
						let os = localStorage.getItem("os");
						let trackingId = localStorage.getItem("trackingId")
						let contentPosition = this.contentPosition;
						let carouselPosition = this.carouselPosition;
						const contentType = this.props.contentinfo[0].generalInfo.type;
						if (!this.contentPosition) {
							var carosuelDetTab = sessionStorage
								.getItem(this.props.match.params.Id)
								.split("@@");

							if (carosuelDetTab.length > 0) {
								contentPosition = carosuelDetTab[0];
								carouselPosition = parseInt(carosuelDetTab[1]);
								this.tabName = carosuelDetTab[2];
								this.contentSource = carosuelDetTab[3];
								this.sourceName = carosuelDetTab[4];
							}

						}
						
						myplexAPI
							.updatePlayerMou(
								results.generalInfo._id,
								duration,
								timestamp,
								results.mediaSessionToken,
								tab,
								cTitle,
								source, contentPosition,
								carouselPosition, os, contentType, trackingId
							)
							.then((res) => {
								// console.log(res)
								clock.clear();
							});
						//player.destroy();
						// player.reset();

						// player.off();
					});
					const throttleFunction = (func, delay) => {
						let prev = 0;
						return (...args) => {
							let now = new Date().getTime();
							if (now - prev > delay) {
								prev = now;
								return func(...args);
							}
						};
					};
					player.on(
						"seeking",
						throttleFunction(() => {
							// player.on("seeking", () => {
							// console.log(_self.flag);
							if (_self.flag == 0) {
								let playerDiv = document.querySelector("video");
								_self.seekedStart = parseInt(playerDiv.currentTime);
								_self.flag = 1;
							}

							//});
						}, 1500)
					);

					player.on("seeked", () => {
						// console.log(_self.flag);
						if (_self.flag == 1) {
							if (window.timer > 600) {
								let dur = Number(localStorage.getItem("wintimer"));
								localStorage.setItem("wintimer", dur - 600);
							} //window.timer=0;
							else {
								localStorage.setItem("wintimer", 600);
							}
							let playerDiv = document.querySelector("video");
							let seekedEnd = parseInt(playerDiv.currentTime);
							// console.log("seekstart", _self.seekedStart);
							// console.log("seekend", seekedEnd);
							// firebaseEvents.contentSeeked(
							//   results,
							//   _self.contentPosition,
							//   _self.carouselPosition,
							//   _self.tabName,
							//   _self.seekedStart,
							//   seekedEnd
							// );
							// let seekedEventData = {
							//     'seek_from': parseFloat(_self.seekedStart) * 1000,
							//     'seek_to': parseFloat(seekedEnd) * 1000
							// }

							let videoInSecs1 = playerDiv.duration;
							let pc = parseInt((seekedEnd / videoInSecs1) * 100);
							lensEvents.videoSeeked(
								results,
								_self.contentPosition,
								_self.carouselPosition,
								_self.tabName,
								_self.contentSource,
								_self.sourceName,
								_self.seekedStart,
								seekedEnd,
								pc,
								_self.completed,
								_self.studioname
							);
							_self.flag = 0;
						}
					});

					// player.muted(false);

					player.on("error", function () {
						player.error(null);
						that.setState({
							flowPlayerError: true,
						});
					});

					player.poster(ParseImgURL(Imgarr, "mdpi", "coverposter"));
					// player.play();
				});
			}
			if (status === "SUCCESS") {
				// this.events(this.props, results, video_info);
				// this.videoLoop(results);
				// document.querySelector('.vjs-big-play-button').style.display  = 'none';
				/* PPV Implementation */
				window.setTimeout(
					function () {
						/* If SeekEnabled false then we have to disable the forward and backward buttons and seekbar*/
						// const seekButtons = document.getElementsByClassName('vjs-seek-button'); this is for default skin
						const seekButtonForward = document.getElementsByClassName(
							"vjs-forward-control"
						);
						const seekButtonRewind =
							document.getElementsByClassName("vjs-rewind-control");
						const player = window.videojs && window.videojs("player");
						if (player && results.playerConfig) {
							if (results.playerConfig.seekEnabled) {
								player.controlBar.progressControl.disable(); //seek-bar disable
								if (seekButtonForward) {
									seekButtonForward[0].classList.add("hidden");
									seekButtonForward[0].classList.add("hidden");
								}
								if (seekButtonRewind) {
									seekButtonRewind[0].classList.add("hidden");
									seekButtonRewind[0].classList.add("hidden");
								}
							} else {
								player.controlBar.progressControl.enable(); //seek-bar enable
								if (seekButtonForward) {
									seekButtonForward[0].classList.remove("hidden");
									seekButtonForward[0].classList.remove("hidden");
								}
								if (seekButtonRewind) {
									seekButtonRewind[0].classList.remove("hidden");
									seekButtonRewind[0].classList.remove("hidden");
								}
							}
							if (results.playerConfig.updateStatusIntervalInSec) {
								const internal =
									parseInt(results.playerConfig.updateStatusIntervalInSec) *
									1000;
								var video = document.querySelector("video");
								this.setState({
									isPPVInterval: true,
								});

								this.pauseInterval = window.setInterval(
									function () {
										const isPaused = _self.isPaused;
										// console.log(video.readyState)
										// console.log('isPaused', isPaused)
										if (isPaused) {
											// this.playerUpdate(results, "complete", player);
											// clearInterval(pauseInterval);
											return false;
										}
										if (player.currentTime() !== 0) {
											// console.log(player.currentTime())
											this.playerUpdate(results, "pause", player);
										}
									}.bind(this),
									internal
								);
							}
						}
					}.bind(this),
					1000
				);
				/* PPV Implementation */

				this.events(this.props, results, video_info);
			} else {
				// // debugger;
				// // eslint-disable-next-line no-unused-vars
				// var elem = document.getElementById("player");
				// window.videojs(elem).disable(true);
				// window.videojs(elem).stop();
				// elem.onclick = e => {
				//   window.videojs(elem).disable(true);
				//   window.videojs(elem).stop();
				//   document.getElementById("profile_img").click();
				//   window.setTimeout(function () {
				//     // document.querySelector('.vjs-big-play-button').style.display  = 'block';
				//   }, 500);
				// };
			}
		}
		this._videoPlay();
	};
	skipButtons = (skipData) => {
		let video = document.querySelector("video");
		if (skipData) {
			if (skipData.skipIntro && skipData.skipIntro.length > 0) {
				var skipIntro = skipData.skipIntro[0];

				if (video) {
					let currentTime = Math.round(video.currentTime);
					let skipStartPosition = Math.round(skipIntro.skipStartPosition);
					let skipEndPosition = Math.round(skipIntro.skipEndPosition);
					let skipIntroButton = document.getElementById("skipIntroButton");
					// console.log('skipStartPosition', skipStartPosition, ' currentTime ', currentTime, ' skipEndPosition ', skipEndPosition )
					if (
						currentTime >= skipStartPosition &&
						currentTime <= skipEndPosition
					) {
						this.createbutton(skipIntroButton, "skipIntroButton", skipIntro);
						// console.log('currentTime ',currentTime)
					} else {
						if (skipIntroButton) {
							// clearInterval(skipInterval);
							skipIntroButton.classList.add("hidden");
						}
					}
				}
			}
			if (skipData.scenes && skipData.scenes.length > 0) {
				var scenes = skipData.scenes[0];

				if (video) {
					let currentTime = Math.round(video.currentTime);
					let skipStartPosition = Math.round(scenes.skipStartPosition);
					let skipEndPosition = Math.round(scenes.skipEndPosition);
					let sceneButton = document.getElementById("sceneButton");
					// console.log('skipStartPosition', skipStartPosition, ' currentTime ', currentTime, ' skipEndPosition ', skipEndPosition )
					if (
						currentTime >= skipStartPosition &&
						currentTime <= skipEndPosition
					) {
						this.createbutton(sceneButton, "sceneButton", scenes);
						// console.log('currentTime ',currentTime)
					} else {
						if (sceneButton) {
							// clearInterval(skipInterval);
							sceneButton.classList.add("hidden");
						}
					}
				}
			}
			if (skipData.skipEndCredit && skipData.skipEndCredit.length > 0) {
				var EndCredit = skipData.skipEndCredit[0];

				if (video) {
					let currentTime = Math.round(video.currentTime);
					let skipStartPosition = Math.round(EndCredit.skipStartPosition);
					let skipEndPosition = Math.round(EndCredit.skipEndPosition);
					let EndButton = document.getElementById("EndButton");
					// console.log('skipStartPosition', skipStartPosition, ' currentTime ', currentTime, ' skipEndPosition ', skipEndPosition )
					if (
						currentTime >= skipStartPosition &&
						currentTime <= skipEndPosition
					) {
						this.createbutton(EndButton, "EndButton", EndCredit);
						// console.log('currentTime ',currentTime)
					} else {
						if (EndButton) {
							// clearInterval(skipInterval);
							EndButton.classList.add("hidden");
						}
					}
				}
			}
		}
	};

	createbutton = (skipIntroButton, id, data) => {
		if (skipIntroButton === null) {
			let div = document.createElement("div");
			div.className = "vast-skip-button";
			div.addEventListener("click", () =>
				this.skipIntroduction(data.skipEndPosition)
			);

			// div.setAttribute('onclick', () => this.skipIntroduction(skipEndPosition));
			// div.onclick = this.skipIntroduction;
			div.id = id;
			div.innerHTML = `<p class="vast-skip-button-text">${data.skipDisplay}</p>`;
			document.getElementById("player").appendChild(div);
		} else {
			skipIntroButton.classList.remove("hidden");
		}
	};

	gettags(tags) {
		var i;
		var tagData = "";

		for (i = 0; i < tags.length; i++) {
			tagData = tagData + "," + tags[i].name;
		}

		return tagData;
	}

	playerUpdate = (data, action, api) => {
		//console.log(action)
		const contentId = data._id;
		const contentType = data.generalInfo.type;
		let mediaSessionToken = "";
		if (data.mediaSessionToken) {
			mediaSessionToken = data.mediaSessionToken;
		}
		//console.log(api.video.time);
		const id = contentId;
		// console.log('contentId', contentId)
		const stream = contentType;
		//let elapsedTime = Math.round(api.cache_.currentTime);
		let elapsedTime = api !== undefined && api.cache_ !== undefined && api.cache_.currentTime !== undefined ? Math.round(api.cache_.currentTime): 0;
		// if(api.cache_.currentTime==api.duration()){
		//   let elapsedTime = 0 ;
		// }
		if (action == "delete" || action == "complete") {
			elapsedTime = 0;
		}
		const video_type = data.generalInfo.type;
		if (
			video_type !== "live" &&
			video_type !== "program"
		) {
			// console.log(video_type)
			/*if(action === "complete"){
					  elapsedTime = 0;
				  }*/
			myplexAPI
				.playerStatus(id, action, stream, elapsedTime, mediaSessionToken)
				.then((response) => {
					// console.log(response);
					// console.log(action)
				});
		}
	};
	_captureforward = () => {
		let playerDiv = document.querySelector("video");
		this.flag = 1;
		this.seekedStart = parseInt(playerDiv.currentTime) - 10;
		// console.log("start", this.seekedStart);
	};
	_capturerewind = () => {
		let playerDiv = document.querySelector("video");
		this.flag = 1;
		this.seekedStart = parseInt(playerDiv.currentTime) + 10;
		//  console.log("rev", this.seekedStart);
	};
	_captureSlider = () => {
		//  console.log("seekslider")
		if (this.flag == 0) {
			let playerDiv = document.querySelector("video");
			this.flag = 2;
			this.seekedStart = parseInt(playerDiv.currentTime);
			// console.log("seekslider",this.seekedStart);
		}
	};
	_captureSlider1 = () => {
		// console.log("seek")
		this.flag = 1;
	};

	getGenreInfo = (data) => {
		const genre = [];
		if (data.content.genre.length > 0) {
			data.content.genre.map((value) => genre.push(value.name));
		}
		return genre.join();
	};
	events = (props, data, video_info) => {
		if (data.videos.status === "SUCCESS") {
			clock.clear();
			// console.log(data, video_info)
			const auth = props.Auth;
			var elem = document.getElementById("player");
			var video = document.querySelector("video");
			var api = window.videojs(elem);

			if (auth) {
				if (video !== null) {
					var b = setInterval(() => {
						if (video.readyState >= 3) {
							const video_type = data.generalInfo.type;
							// console.log(video_type);
							if (video_type !== "live" && video_type !== "program") {
								// console.log(video_info.elapsedTime, video.duration)
								let elapsedTime = video_info.elapsedTime;
								const completed = Math.round(
									(video.currentTime / video.duration) * 100
								);
								// console.log('completed', completed)
								// When used watched 100% then we are playing video starting onWords
								if (99 < completed) {
									elapsedTime = 0;
								}
								// console.log(elapsedTime);
								if (
									Math.round(elapsedTime) !== Math.round(video.duration) &&
									elapsedTime != 0
								) {
									//Latest version
									video.currentTime = elapsedTime; //Latest version
									// api.seek(elapsedTime);
									// api.play();
								}
							}
							clearInterval(b);
						}
					}, 2000);
				}
			}
		}
	};
	hideparentalcontrol = () => {
		setTimeout(function () {
			const parentControl = document.getElementById("parentControl");

			if (parentControl && !parentControl.classList.contains("subscribeuser")) {
				document.getElementById("parentControl").style.display = "none";
			}
		}, 15000);
	};
	// skipIntroduction = (jumpTime) => {
	//   const player = window.videojs("player");
	//   var video = document.querySelector("video");
	//   // if (this.state.skipIntro) {
	//   //   // console.log(this.state.contentDetails);
	//   //   if (player.hasStarted_) {
	//   //     // console.log(this.state.contentDetails);
	//   //     video.currentTime = this.state.skipIntro.jumpTo;
	//   //     const skipIntroButton = document.getElementById("skipIntroButton");
	//   //     if (skipIntroButton) {
	//   //       skipIntroButton.classList.add("hidden");
	//   //     }
	//   //   }
	//   // }
	//   // video.currentTime = this.state.skipIntro.jumpTo;
	//   console.log();
	//   video.currentTime =jumpTime;
	//   const skipIntroButton = document.getElementById("skipIntroButton");
	//   if (skipIntroButton) {
	//     skipIntroButton.classList.add("hidden");
	//   }
	// };
	skipIntroduction = () => {
		const player = window.videojs("player");
		var video = document.querySelector("video");
		if (this.state.skipIntro) {
			// console.log(this.state.contentDetails);
			if (player.hasStarted_) {
				// console.log(this.state.contentDetails);
				video.currentTime = this.state.skipIntro.jumpTo;
				const skipIntroButton = document.getElementById("skipIntroButton");
				if (skipIntroButton) {
					skipIntroButton.classList.add("hidden");
				}
			}
		}
	};
	calculate_age = (dob) => {
		var birthDate = new Date(dob);
		var diff_ms = Date.now() - birthDate.getTime();
		var age_dt = new Date(diff_ms);

		return Math.abs(age_dt.getUTCFullYear() - 1970);
	};
	heartbeatFunction = function () {
		setInterval(() => {
			if (heartbeat.totalSeconds !== 0) {
				myplexAPI
					.heartbeat(
						this.props.videoId,
						heartbeat.totalSeconds,
						Math.floor(Date.now())
					)
					.then(() => { });
				heartbeat.clear();
			}
		}, 30000);
	};
	playermute = () => {
		if (document.getElementById("audiosection").style.display !== "none") {
			var player = document.getElementById("player");

			var api = window.videojs(player);
			api.muted(false);
			document.getElementById("audiosection").style.display = "none";
		}
	};
	getproperties = () => {
		if(sessionStorage.getItem('properties') === undefined || sessionStorage.getItem('properties') === null){
			myplexAPI.properties().then(response => {
				if(response.data.code === 200 && response.data.status === 'SUCCESS' && response.data.properties){
					this.setAntiTobaccoData(response.data.properties);
				};				
			});
		}else{
			this.setAntiTobaccoData(JSON.parse(sessionStorage.getItem('properties')));
		}		 
	}
	setAntiTobaccoData = (dat) => {
		if(dat?.enabletobaccoAd_pwa && (dat?.enabletobaccoAd_pwa === true || dat?.enabletobaccoAd_pwa === 'true')){
			//this.setState({"tobaccoAd": true});
		}
		if(dat?.antiTobaccoWarningUrl && dat?.antiTobaccoWarningUrl.length > 0){
			this.setState({"tobaccoAdUrl": dat?.antiTobaccoWarningUrl});
		}
	}
	tobaccoImageDispaly = () => {
		var propsData =  sessionStorage.getItem('properties') !== undefined && sessionStorage.getItem('properties') !== null && JSON.parse(sessionStorage.getItem('properties'));
		if(propsData?.enabletobaccoAd_pwa && (propsData?.enabletobaccoAd_pwa === true || propsData?.enabletobaccoAd_pwa === 'true')){
			let _self = this;
			_self.tobaccoStripShowAfterContentComplete = false;
			_self.setState({
				tobaccoAd: true,
			});
			window.setTimeout(function () {
				_self.setState({
					tobaccoAd: false,
				});
			}, propsData?.tobaccoWarning ?  (propsData?.tobaccoWarning)*1000 : 5000);
		}		
	}
	render() {
		// console.log("hhh",this.props.contentinfo)
		return (
			<div>
				{this.state.errorMsg && (
					<div className="error-message">{this.state.errorMsg}</div>
				)}

				<Modalview
					modalshow={this.state.flowPlayerError}
					modalonHide={this.flowPlayerError}
					toastMessage={this.state.toastMessage}
				/>
				{this.state.subscribeAlertPopup && (
					<SubscriptionAlertBox
						subscribeAlertPopup={this.state.subscribeAlertPopup}
						message={this.state.toastMessage}
						clickSubscribe={this.clickSubscribe}
						modalonHide={this.subscribeAlertClose}
					/>
				)}
				{this.state.showAdBlockerPopUp && (
					<SubscriptionAlertBox
						subscribeAlertPopup={this.state.showAdBlockerPopUp}
						message={this.state.adBlockerMessage}
						clickSubscribe={this.clickSubscribe}
						modalonHide={this.subscribeAlertClose}
						adBlockerTitle={this.state.adBlockerTitle}
						adBlockerButtonText={this.state.adBlockerButtonText}
						popupType='adBlocker'
					/>
				)}
				{/* {this.state.checkingThumbnail && ( */}
				
				<div className="videojs_player_section">
					{this.state.tobaccoAd && 
						<div className="tobaccoImg">

							<img src={this.state.tobaccoAdUrl} alt="tobacco" />
						</div>
					}
					<div className="videoPlayerDiv">
					<video
						id={"player"}
						playsInline
						data-setup='{"fluid": true}'
						// muted={true}
						className="video-js vjs-big-play-centered"
						controls
					>
						{this.props &&
							this.props.contentinfo &&
							this.props.contentinfo[0] &&
							this.props.contentinfo[0].subtitles &&
							this.props.contentinfo[0].subtitles.values.length > 0 && (
								<track
									enabled="true"
									label="English"
									kind="subtitles"
									srcLang="en"
									src={this.props.contentinfo[0].subtitles.values[0].link_sub.replace(
										".srt",
										".vtt"
									)}
									// src={this.state.subtitleUrl}
									default
								/>
							)}

						{this.props &&
							this.props.contentinfo &&
							this.props.contentinfo[0] &&
							this.props.contentinfo[0].thumbnailSeekPreview !== "" && (
								<track
									kind="metadata"
									src={this.props.contentinfo[0].thumbnailSeekPreview}
								/>
							)}
					</video>
					</div>
					{isMobile ? (
						<div id="companionDivmobile" style={{ textAlign: "center" }}></div>
					) : (
						<div id="companionDiv" style={{ textAlign: "center" }}>
							{" "}
						</div>
					)}

					{this.state.contentDetails && (
						<div
							className="parentControl player_parentcontrol"
							id="parentControl"
						>
							{this.state.contentDetails.content.categoryType != "" && (
								<span className="rating_category_type">
									{this.state.contentDetails.content.categoryType}
								</span>
							)}
							<span className="rating_category_name">
								{this.state.contentDetails.content.categoryName}
							</span>
						</div>
					)}
				</div>
				{!isMobile && (
					<div
						onClick={this.playermute}
						className="audiosection"
						id="audiosection"
						style={{ display: "none" }}
					>
						<h4>Tap to unmute</h4>
						{/* <img src={playerunmute} alt="muteimg" /> */}
						<img src={playermute} alt="muteimg" />
					</div>
				)}
				{/* )} */}
			</div>
		);
	}
}

export default withRouter(PassPlayer);
